import { emptySplitApi as api } from "./baseApi";
export const addTagTypes = [
  "InviteController",
  "AdminCannedResponseController",
  "AdminComplianceCertificateController",
  "KnowledgeArticleController",
  "AdminMaintenanceOpsController",
  "AdminMaintenanceAssetController",
  "AdminMaintenanceTicketController",
  "PropertyMigrationController",
  "AdminPadelBookingController",
  "AdminPreventiveMaintenanceController",
  "AdminVendorController",
  "PaymentController",
  "FinanceController",
  "InternetBillingController",
  "InternetInvoiceController",
  "InternetPackagesController",
  "InternetSubscriptionController",
  "InternetUsageController",
  "InvoiceController",
  "ItemController",
  "MaintenanceTicketController",
  "MediaController",
  "MeterController",
  "NoticeController",
  "PadelBookingController",
  "PasswordResetRequestController",
  "PingController",
  "PropertyController",
  "PropertyInvoiceController",
  "UserController",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postAddInvite: build.mutation<
        PostAddInviteApiResponse,
        PostAddInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/add-invite`,
          method: "POST",
          body: queryArg.inviteData,
        }),
        invalidatesTags: ["InviteController"],
      }),
      patchAdminCannedResponsesById: build.mutation<
        PatchAdminCannedResponsesByIdApiResponse,
        PatchAdminCannedResponsesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/canned-responses/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.cannedResponsePartialExcludingIdCreatedAt,
        }),
        invalidatesTags: ["AdminCannedResponseController"],
      }),
      getAdminCannedResponsesById: build.query<
        GetAdminCannedResponsesByIdApiResponse,
        GetAdminCannedResponsesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/canned-responses/${queryArg.id}`,
        }),
        providesTags: ["AdminCannedResponseController"],
      }),
      deleteAdminCannedResponsesById: build.mutation<
        DeleteAdminCannedResponsesByIdApiResponse,
        DeleteAdminCannedResponsesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/canned-responses/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AdminCannedResponseController"],
      }),
      postAdminCannedResponses: build.mutation<
        PostAdminCannedResponsesApiResponse,
        PostAdminCannedResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/canned-responses`,
          method: "POST",
          body: queryArg.cannedResponseExcludingIdCreatedAtUpdatedAt,
        }),
        invalidatesTags: ["AdminCannedResponseController"],
      }),
      getAdminCannedResponses: build.query<
        GetAdminCannedResponsesApiResponse,
        GetAdminCannedResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/canned-responses`,
          params: { category: queryArg.category },
        }),
        providesTags: ["AdminCannedResponseController"],
      }),
      patchAdminComplianceCertificatesById: build.mutation<
        PatchAdminComplianceCertificatesByIdApiResponse,
        PatchAdminComplianceCertificatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/compliance-certificates/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.complianceCertificatePartialExcludingIdCreatedAt,
        }),
        invalidatesTags: ["AdminComplianceCertificateController"],
      }),
      getAdminComplianceCertificatesById: build.query<
        GetAdminComplianceCertificatesByIdApiResponse,
        GetAdminComplianceCertificatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/compliance-certificates/${queryArg.id}`,
        }),
        providesTags: ["AdminComplianceCertificateController"],
      }),
      deleteAdminComplianceCertificatesById: build.mutation<
        DeleteAdminComplianceCertificatesByIdApiResponse,
        DeleteAdminComplianceCertificatesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/compliance-certificates/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AdminComplianceCertificateController"],
      }),
      postAdminComplianceCertificates: build.mutation<
        PostAdminComplianceCertificatesApiResponse,
        PostAdminComplianceCertificatesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/compliance-certificates`,
          method: "POST",
          body: queryArg.complianceCertificateExcludingIdCreatedAtUpdatedAtIsExpired,
        }),
        invalidatesTags: ["AdminComplianceCertificateController"],
      }),
      getAdminComplianceCertificates: build.query<
        GetAdminComplianceCertificatesApiResponse,
        GetAdminComplianceCertificatesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/compliance-certificates`,
          params: {
            propertyId: queryArg.propertyId,
            certType: queryArg.certType,
            expiringSoon: queryArg.expiringSoon,
          },
        }),
        providesTags: ["AdminComplianceCertificateController"],
      }),
      getAdminInvitesVisits: build.query<
        GetAdminInvitesVisitsApiResponse,
        GetAdminInvitesVisitsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/invites-visits`,
          params: {
            development: queryArg.development,
            phase: queryArg.phase,
            propertyNumber: queryArg.propertyNumber,
            propertyId: queryArg.propertyId,
            visitorType: queryArg.visitorType,
            invitedByType: queryArg.invitedByType,
            revoked: queryArg.revoked,
            scanned: queryArg.scanned,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            search: queryArg.search,
          },
        }),
        providesTags: ["InviteController"],
      }),
      patchAdminKnowledgeArticlesById: build.mutation<
        PatchAdminKnowledgeArticlesByIdApiResponse,
        PatchAdminKnowledgeArticlesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/knowledge-articles/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["KnowledgeArticleController"],
      }),
      deleteAdminKnowledgeArticlesById: build.mutation<
        DeleteAdminKnowledgeArticlesByIdApiResponse,
        DeleteAdminKnowledgeArticlesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/knowledge-articles/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["KnowledgeArticleController"],
      }),
      postAdminKnowledgeArticles: build.mutation<
        PostAdminKnowledgeArticlesApiResponse,
        PostAdminKnowledgeArticlesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/knowledge-articles`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["KnowledgeArticleController"],
      }),
      getAdminKnowledgeArticles: build.query<
        GetAdminKnowledgeArticlesApiResponse,
        GetAdminKnowledgeArticlesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/knowledge-articles`,
          params: {
            category: queryArg.category,
            published: queryArg.published,
          },
        }),
        providesTags: ["KnowledgeArticleController"],
      }),
      getAdminMaintenanceAccountsPayable: build.query<
        GetAdminMaintenanceAccountsPayableApiResponse,
        GetAdminMaintenanceAccountsPayableApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/accounts-payable`,
          params: { vendorId: queryArg.vendorId },
        }),
        providesTags: ["AdminMaintenanceOpsController"],
      }),
      getAdminMaintenanceAgingReport: build.query<
        GetAdminMaintenanceAgingReportApiResponse,
        GetAdminMaintenanceAgingReportApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/aging-report`,
          params: { propertyId: queryArg.propertyId },
        }),
        providesTags: ["AdminMaintenanceOpsController"],
      }),
      getAdminMaintenanceAssetCostHistoryByAssetId: build.query<
        GetAdminMaintenanceAssetCostHistoryByAssetIdApiResponse,
        GetAdminMaintenanceAssetCostHistoryByAssetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/asset-cost-history/${queryArg.assetId}`,
        }),
        providesTags: ["AdminMaintenanceOpsController"],
      }),
      postAdminMaintenanceCostItemsByItemIdApprove: build.mutation<
        PostAdminMaintenanceCostItemsByItemIdApproveApiResponse,
        PostAdminMaintenanceCostItemsByItemIdApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/cost-items/${queryArg.itemId}/approve`,
          method: "POST",
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      patchAdminMaintenanceCostItemsByItemId: build.mutation<
        PatchAdminMaintenanceCostItemsByItemIdApiResponse,
        PatchAdminMaintenanceCostItemsByItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/cost-items/${queryArg.itemId}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      deleteAdminMaintenanceCostItemsByItemId: build.mutation<
        DeleteAdminMaintenanceCostItemsByItemIdApiResponse,
        DeleteAdminMaintenanceCostItemsByItemIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/cost-items/${queryArg.itemId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      getAdminMaintenanceResponseMetrics: build.query<
        GetAdminMaintenanceResponseMetricsApiResponse,
        GetAdminMaintenanceResponseMetricsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance/response-metrics`,
          params: {
            propertyId: queryArg.propertyId,
            from: queryArg["from"],
            to: queryArg.to,
          },
        }),
        providesTags: ["AdminMaintenanceOpsController"],
      }),
      postAdminMaintenanceRunEscalations: build.mutation<
        PostAdminMaintenanceRunEscalationsApiResponse,
        PostAdminMaintenanceRunEscalationsApiArg
      >({
        query: () => ({
          url: `/admin/maintenance/run-escalations`,
          method: "POST",
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      getAdminMaintenanceAssetsByIdTicketHistory: build.query<
        GetAdminMaintenanceAssetsByIdTicketHistoryApiResponse,
        GetAdminMaintenanceAssetsByIdTicketHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-assets/${queryArg.id}/ticket-history`,
        }),
        providesTags: ["AdminMaintenanceAssetController"],
      }),
      patchAdminMaintenanceAssetsById: build.mutation<
        PatchAdminMaintenanceAssetsByIdApiResponse,
        PatchAdminMaintenanceAssetsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-assets/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.maintenanceAssetPartialExcludingIdCreatedAt,
        }),
        invalidatesTags: ["AdminMaintenanceAssetController"],
      }),
      getAdminMaintenanceAssetsById: build.query<
        GetAdminMaintenanceAssetsByIdApiResponse,
        GetAdminMaintenanceAssetsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-assets/${queryArg.id}`,
        }),
        providesTags: ["AdminMaintenanceAssetController"],
      }),
      deleteAdminMaintenanceAssetsById: build.mutation<
        DeleteAdminMaintenanceAssetsByIdApiResponse,
        DeleteAdminMaintenanceAssetsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-assets/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AdminMaintenanceAssetController"],
      }),
      postAdminMaintenanceAssets: build.mutation<
        PostAdminMaintenanceAssetsApiResponse,
        PostAdminMaintenanceAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-assets`,
          method: "POST",
          body: queryArg.maintenanceAssetExcludingIdCreatedAtUpdatedAtTicketCount,
        }),
        invalidatesTags: ["AdminMaintenanceAssetController"],
      }),
      getAdminMaintenanceAssets: build.query<
        GetAdminMaintenanceAssetsApiResponse,
        GetAdminMaintenanceAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-assets`,
          params: {
            propertyId: queryArg.propertyId,
            category: queryArg.category,
          },
        }),
        providesTags: ["AdminMaintenanceAssetController"],
      }),
      postAdminMaintenanceTicketsByIdCostItems: build.mutation<
        PostAdminMaintenanceTicketsByIdCostItemsApiResponse,
        PostAdminMaintenanceTicketsByIdCostItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-tickets/${queryArg.id}/cost-items`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      getAdminMaintenanceTicketsByIdCostItems: build.query<
        GetAdminMaintenanceTicketsByIdCostItemsApiResponse,
        GetAdminMaintenanceTicketsByIdCostItemsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-tickets/${queryArg.id}/cost-items`,
        }),
        providesTags: ["AdminMaintenanceOpsController"],
      }),
      postAdminMaintenanceTicketsByIdMerge: build.mutation<
        PostAdminMaintenanceTicketsByIdMergeApiResponse,
        PostAdminMaintenanceTicketsByIdMergeApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-tickets/${queryArg.id}/merge`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      postAdminMaintenanceTicketsByIdSplit: build.mutation<
        PostAdminMaintenanceTicketsByIdSplitApiResponse,
        PostAdminMaintenanceTicketsByIdSplitApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-tickets/${queryArg.id}/split`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminMaintenanceOpsController"],
      }),
      patchAdminMaintenanceTicketsById: build.mutation<
        PatchAdminMaintenanceTicketsByIdApiResponse,
        PatchAdminMaintenanceTicketsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-tickets/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminMaintenanceTicketController"],
      }),
      getAdminMaintenanceTickets: build.query<
        GetAdminMaintenanceTicketsApiResponse,
        GetAdminMaintenanceTicketsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/maintenance-tickets`,
          params: {
            status: queryArg.status,
            propertyId: queryArg.propertyId,
            category: queryArg.category,
          },
        }),
        providesTags: ["AdminMaintenanceTicketController"],
      }),
      postAdminMigratePropertyOwners: build.mutation<
        PostAdminMigratePropertyOwnersApiResponse,
        PostAdminMigratePropertyOwnersApiArg
      >({
        query: () => ({
          url: `/admin/migrate-property-owners`,
          method: "POST",
        }),
        invalidatesTags: ["PropertyMigrationController"],
      }),
      getAdminPadelBookingsById: build.query<
        GetAdminPadelBookingsByIdApiResponse,
        GetAdminPadelBookingsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/padel-bookings/${queryArg.id}` }),
        providesTags: ["AdminPadelBookingController"],
      }),
      getAdminPadelBookings: build.query<
        GetAdminPadelBookingsApiResponse,
        GetAdminPadelBookingsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/padel-bookings`,
          params: {
            date: queryArg.date,
            propertyId: queryArg.propertyId,
            status: queryArg.status,
          },
        }),
        providesTags: ["AdminPadelBookingController"],
      }),
      postAdminPreventiveMaintenanceGenerateDue: build.mutation<
        PostAdminPreventiveMaintenanceGenerateDueApiResponse,
        PostAdminPreventiveMaintenanceGenerateDueApiArg
      >({
        query: () => ({
          url: `/admin/preventive-maintenance/generate-due`,
          method: "POST",
        }),
        invalidatesTags: ["AdminPreventiveMaintenanceController"],
      }),
      postAdminPreventiveMaintenanceByIdGenerate: build.mutation<
        PostAdminPreventiveMaintenanceByIdGenerateApiResponse,
        PostAdminPreventiveMaintenanceByIdGenerateApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/preventive-maintenance/${queryArg.id}/generate`,
          method: "POST",
        }),
        invalidatesTags: ["AdminPreventiveMaintenanceController"],
      }),
      patchAdminPreventiveMaintenanceById: build.mutation<
        PatchAdminPreventiveMaintenanceByIdApiResponse,
        PatchAdminPreventiveMaintenanceByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/preventive-maintenance/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.preventiveMaintenancePartialExcludingIdCreatedAt,
        }),
        invalidatesTags: ["AdminPreventiveMaintenanceController"],
      }),
      getAdminPreventiveMaintenanceById: build.query<
        GetAdminPreventiveMaintenanceByIdApiResponse,
        GetAdminPreventiveMaintenanceByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/preventive-maintenance/${queryArg.id}`,
        }),
        providesTags: ["AdminPreventiveMaintenanceController"],
      }),
      deleteAdminPreventiveMaintenanceById: build.mutation<
        DeleteAdminPreventiveMaintenanceByIdApiResponse,
        DeleteAdminPreventiveMaintenanceByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/preventive-maintenance/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AdminPreventiveMaintenanceController"],
      }),
      postAdminPreventiveMaintenance: build.mutation<
        PostAdminPreventiveMaintenanceApiResponse,
        PostAdminPreventiveMaintenanceApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/preventive-maintenance`,
          method: "POST",
          body: queryArg.preventiveMaintenanceExcludingIdCreatedAtUpdatedAtLastGeneratedTicketIdLastCompletedDate,
        }),
        invalidatesTags: ["AdminPreventiveMaintenanceController"],
      }),
      getAdminPreventiveMaintenance: build.query<
        GetAdminPreventiveMaintenanceApiResponse,
        GetAdminPreventiveMaintenanceApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/preventive-maintenance`,
          params: {
            propertyId: queryArg.propertyId,
            dueOnly: queryArg.dueOnly,
          },
        }),
        providesTags: ["AdminPreventiveMaintenanceController"],
      }),
      postAdminVendorsByIdRecordJob: build.mutation<
        PostAdminVendorsByIdRecordJobApiResponse,
        PostAdminVendorsByIdRecordJobApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/vendors/${queryArg.id}/record-job`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["AdminVendorController"],
      }),
      patchAdminVendorsById: build.mutation<
        PatchAdminVendorsByIdApiResponse,
        PatchAdminVendorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/vendors/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.vendorPartialExcludingIdCreatedAt,
        }),
        invalidatesTags: ["AdminVendorController"],
      }),
      getAdminVendorsById: build.query<
        GetAdminVendorsByIdApiResponse,
        GetAdminVendorsByIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/vendors/${queryArg.id}` }),
        providesTags: ["AdminVendorController"],
      }),
      deleteAdminVendorsById: build.mutation<
        DeleteAdminVendorsByIdApiResponse,
        DeleteAdminVendorsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/vendors/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["AdminVendorController"],
      }),
      postAdminVendors: build.mutation<
        PostAdminVendorsApiResponse,
        PostAdminVendorsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/vendors`,
          method: "POST",
          body: queryArg.vendorExcludingIdCreatedAtUpdatedAt,
        }),
        invalidatesTags: ["AdminVendorController"],
      }),
      getAdminVendors: build.query<
        GetAdminVendorsApiResponse,
        GetAdminVendorsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/vendors`,
          params: {
            category: queryArg.category,
            activeOnly: queryArg.activeOnly,
          },
        }),
        providesTags: ["AdminVendorController"],
      }),
      postApiCreateSubscriptionIntent: build.mutation<
        PostApiCreateSubscriptionIntentApiResponse,
        PostApiCreateSubscriptionIntentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/create-subscription-intent`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      getFinanceOutstandingLevies: build.query<
        GetFinanceOutstandingLeviesApiResponse,
        GetFinanceOutstandingLeviesApiArg
      >({
        query: () => ({ url: `/finance/outstanding-levies` }),
        providesTags: ["FinanceController"],
      }),
      getFinancePayments: build.query<
        GetFinancePaymentsApiResponse,
        GetFinancePaymentsApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/payments`,
          params: {
            name: queryArg.name,
            email: queryArg.email,
            purpose: queryArg.purpose,
            paymentMethod: queryArg.paymentMethod,
            paymentDate: queryArg.paymentDate,
            development: queryArg.development,
            phase: queryArg.phase,
            type: queryArg["type"],
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["FinanceController"],
      }),
      getFinanceRevenues: build.query<
        GetFinanceRevenuesApiResponse,
        GetFinanceRevenuesApiArg
      >({
        query: (queryArg) => ({
          url: `/finance/revenues`,
          params: { range: queryArg.range },
        }),
        providesTags: ["FinanceController"],
      }),
      postInternetBooster: build.mutation<
        PostInternetBoosterApiResponse,
        PostInternetBoosterApiArg
      >({
        query: (queryArg) => ({
          url: `/internet/booster`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["InternetBillingController"],
      }),
      getInternetProRata: build.query<
        GetInternetProRataApiResponse,
        GetInternetProRataApiArg
      >({
        query: (queryArg) => ({
          url: `/internet/pro-rata`,
          params: {
            propertyId: queryArg.propertyId,
            packageId: queryArg.packageId,
          },
        }),
        providesTags: ["InternetInvoiceController"],
      }),
      postInternetUpgrade: build.mutation<
        PostInternetUpgradeApiResponse,
        PostInternetUpgradeApiArg
      >({
        query: (queryArg) => ({
          url: `/internet/upgrade`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["InternetBillingController"],
      }),
      patchInternetInvoicesById: build.mutation<
        PatchInternetInvoicesByIdApiResponse,
        PatchInternetInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/internet-invoices/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["InternetInvoiceController"],
      }),
      getInternetInvoices: build.query<
        GetInternetInvoicesApiResponse,
        GetInternetInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/internet-invoices`,
          params: { propertyId: queryArg.propertyId, status: queryArg.status },
        }),
        providesTags: ["InternetInvoiceController"],
      }),
      getInternetPackages: build.query<
        GetInternetPackagesApiResponse,
        GetInternetPackagesApiArg
      >({
        query: () => ({ url: `/internet-packages` }),
        providesTags: ["InternetPackagesController"],
      }),
      getInternetSubscriptionsActive: build.query<
        GetInternetSubscriptionsActiveApiResponse,
        GetInternetSubscriptionsActiveApiArg
      >({
        query: (queryArg) => ({
          url: `/internet-subscriptions/active`,
          params: { propertyId: queryArg.propertyId },
        }),
        providesTags: ["InternetSubscriptionController"],
      }),
      getInternetUsageByPropertyId: build.query<
        GetInternetUsageByPropertyIdApiResponse,
        GetInternetUsageByPropertyIdApiArg
      >({
        query: (queryArg) => ({
          url: `/internet-usage/${queryArg.propertyId}`,
        }),
        providesTags: ["InternetUsageController"],
      }),
      patchInviteMarkAsScannedById: build.mutation<
        PatchInviteMarkAsScannedByIdApiResponse,
        PatchInviteMarkAsScannedByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/invite/markAsScanned/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["InviteController"],
      }),
      postInviteUploadUrl: build.mutation<
        PostInviteUploadUrlApiResponse,
        PostInviteUploadUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/invite/upload-url`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["InviteController"],
      }),
      patchInviteByIdResend: build.mutation<
        PatchInviteByIdResendApiResponse,
        PatchInviteByIdResendApiArg
      >({
        query: (queryArg) => ({
          url: `/invite/${queryArg.id}/resend`,
          method: "PATCH",
        }),
        invalidatesTags: ["InviteController"],
      }),
      patchInviteByIdRevoke: build.mutation<
        PatchInviteByIdRevokeApiResponse,
        PatchInviteByIdRevokeApiArg
      >({
        query: (queryArg) => ({
          url: `/invite/${queryArg.id}/revoke`,
          method: "PATCH",
        }),
        invalidatesTags: ["InviteController"],
      }),
      getInviteByIdVisitLogs: build.query<
        GetInviteByIdVisitLogsApiResponse,
        GetInviteByIdVisitLogsApiArg
      >({
        query: (queryArg) => ({ url: `/invite/${queryArg.id}/visit-logs` }),
        providesTags: ["InviteController"],
      }),
      getInviteById: build.query<GetInviteByIdApiResponse, GetInviteByIdApiArg>(
        {
          query: (queryArg) => ({ url: `/invite/${queryArg.id}` }),
          providesTags: ["InviteController"],
        }
      ),
      postInviteByCodeByCodeSubInvite: build.mutation<
        PostInviteByCodeByCodeSubInviteApiResponse,
        PostInviteByCodeByCodeSubInviteApiArg
      >({
        query: (queryArg) => ({
          url: `/invite-by-code/${queryArg.code}/sub-invite`,
          method: "POST",
          body: queryArg.subInviteData,
        }),
        invalidatesTags: ["InviteController"],
      }),
      getInviteByCodeByCode: build.query<
        GetInviteByCodeByCodeApiResponse,
        GetInviteByCodeByCodeApiArg
      >({
        query: (queryArg) => ({ url: `/invite-by-code/${queryArg.code}` }),
        providesTags: ["InviteController"],
      }),
      getInvites: build.query<GetInvitesApiResponse, GetInvitesApiArg>({
        query: (queryArg) => ({
          url: `/invites`,
          params: { timeZone: queryArg.timeZone },
        }),
        providesTags: ["InviteController"],
      }),
      postInvoiceProperty: build.mutation<
        PostInvoicePropertyApiResponse,
        PostInvoicePropertyApiArg
      >({
        query: (queryArg) => ({
          url: `/invoice/property`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["InvoiceController"],
      }),
      postInvoice: build.mutation<PostInvoiceApiResponse, PostInvoiceApiArg>({
        query: (queryArg) => ({
          url: `/invoice`,
          method: "POST",
          body: queryArg.newInvoice,
        }),
        invalidatesTags: ["InvoiceController"],
      }),
      getInvoices: build.query<GetInvoicesApiResponse, GetInvoicesApiArg>({
        query: (queryArg) => ({
          url: `/invoices`,
          params: {
            development: queryArg.development,
            type: queryArg["type"],
            phase: queryArg.phase,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            isGeneric: queryArg.isGeneric,
            limit: queryArg.limit,
            skip: queryArg.skip,
            order: queryArg.order,
          },
        }),
        providesTags: ["InvoiceController"],
      }),
      postItem: build.mutation<PostItemApiResponse, PostItemApiArg>({
        query: (queryArg) => ({
          url: `/item`,
          method: "POST",
          body: queryArg.item,
        }),
        invalidatesTags: ["ItemController"],
      }),
      getItems: build.query<GetItemsApiResponse, GetItemsApiArg>({
        query: () => ({ url: `/items` }),
        providesTags: ["ItemController"],
      }),
      postKnowledgeArticlesByIdHelpful: build.mutation<
        PostKnowledgeArticlesByIdHelpfulApiResponse,
        PostKnowledgeArticlesByIdHelpfulApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge-articles/${queryArg.id}/helpful`,
          method: "POST",
        }),
        invalidatesTags: ["KnowledgeArticleController"],
      }),
      getKnowledgeArticlesById: build.query<
        GetKnowledgeArticlesByIdApiResponse,
        GetKnowledgeArticlesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/knowledge-articles/${queryArg.id}` }),
        providesTags: ["KnowledgeArticleController"],
      }),
      getKnowledgeArticles: build.query<
        GetKnowledgeArticlesApiResponse,
        GetKnowledgeArticlesApiArg
      >({
        query: (queryArg) => ({
          url: `/knowledge-articles`,
          params: { category: queryArg.category, q: queryArg.q },
        }),
        providesTags: ["KnowledgeArticleController"],
      }),
      patchMaintenanceMyPreferences: build.mutation<
        PatchMaintenanceMyPreferencesApiResponse,
        PatchMaintenanceMyPreferencesApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance/my-preferences`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      getMaintenanceMyPreferences: build.query<
        GetMaintenanceMyPreferencesApiResponse,
        GetMaintenanceMyPreferencesApiArg
      >({
        query: () => ({ url: `/maintenance/my-preferences` }),
        providesTags: ["MaintenanceTicketController"],
      }),
      getMaintenanceTransparencyStats: build.query<
        GetMaintenanceTransparencyStatsApiResponse,
        GetMaintenanceTransparencyStatsApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance/transparency-stats`,
          params: { days: queryArg.days },
        }),
        providesTags: ["MaintenanceTicketController"],
      }),
      getMaintenanceTicketsCommonArea: build.query<
        GetMaintenanceTicketsCommonAreaApiResponse,
        GetMaintenanceTicketsCommonAreaApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/common-area`,
          params: { propertyId: queryArg.propertyId },
        }),
        providesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsUploadUrl: build.mutation<
        PostMaintenanceTicketsUploadUrlApiResponse,
        PostMaintenanceTicketsUploadUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/upload-url`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsByIdConfirmCompletion: build.mutation<
        PostMaintenanceTicketsByIdConfirmCompletionApiResponse,
        PostMaintenanceTicketsByIdConfirmCompletionApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/confirm-completion`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsByIdDispute: build.mutation<
        PostMaintenanceTicketsByIdDisputeApiResponse,
        PostMaintenanceTicketsByIdDisputeApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/dispute`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsByIdPlusOne: build.mutation<
        PostMaintenanceTicketsByIdPlusOneApiResponse,
        PostMaintenanceTicketsByIdPlusOneApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/plus-one`,
          method: "POST",
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsByIdQuoteDecision: build.mutation<
        PostMaintenanceTicketsByIdQuoteDecisionApiResponse,
        PostMaintenanceTicketsByIdQuoteDecisionApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/quote-decision`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsByIdSurvey: build.mutation<
        PostMaintenanceTicketsByIdSurveyApiResponse,
        PostMaintenanceTicketsByIdSurveyApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/survey`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTicketsByIdWatch: build.mutation<
        PostMaintenanceTicketsByIdWatchApiResponse,
        PostMaintenanceTicketsByIdWatchApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/watch`,
          method: "POST",
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      deleteMaintenanceTicketsByIdWatch: build.mutation<
        DeleteMaintenanceTicketsByIdWatchApiResponse,
        DeleteMaintenanceTicketsByIdWatchApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}/watch`,
          method: "DELETE",
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      patchMaintenanceTicketsById: build.mutation<
        PatchMaintenanceTicketsByIdApiResponse,
        PatchMaintenanceTicketsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      postMaintenanceTickets: build.mutation<
        PostMaintenanceTicketsApiResponse,
        PostMaintenanceTicketsApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MaintenanceTicketController"],
      }),
      getMaintenanceTickets: build.query<
        GetMaintenanceTicketsApiResponse,
        GetMaintenanceTicketsApiArg
      >({
        query: (queryArg) => ({
          url: `/maintenance-tickets`,
          params: {
            propertyId: queryArg.propertyId,
            ticketNumber: queryArg.ticketNumber,
          },
        }),
        providesTags: ["MaintenanceTicketController"],
      }),
      getMediaUploadUrlByInviteId: build.query<
        GetMediaUploadUrlByInviteIdApiResponse,
        GetMediaUploadUrlByInviteIdApiArg
      >({
        query: (queryArg) => ({
          url: `/media/upload-url/${queryArg.inviteId}`,
        }),
        providesTags: ["MediaController"],
      }),
      getMeterHistoricByImeiAndStartDateEndDate: build.query<
        GetMeterHistoricByImeiAndStartDateEndDateApiResponse,
        GetMeterHistoricByImeiAndStartDateEndDateApiArg
      >({
        query: (queryArg) => ({
          url: `/meter/historic/${queryArg.imei}/${queryArg.startDate}/${queryArg.endDate}`,
        }),
        providesTags: ["MeterController"],
      }),
      postMeterOrdersStatus: build.mutation<
        PostMeterOrdersStatusApiResponse,
        PostMeterOrdersStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/meter/orders/status`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["MeterController"],
      }),
      getMeterReadByImei: build.query<
        GetMeterReadByImeiApiResponse,
        GetMeterReadByImeiApiArg
      >({
        query: (queryArg) => ({ url: `/meter/read/${queryArg.imei}` }),
        providesTags: ["MeterController"],
      }),
      getMyPropertyInvites: build.query<
        GetMyPropertyInvitesApiResponse,
        GetMyPropertyInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/my-property-invites`,
          params: { timeZone: queryArg.timeZone },
        }),
        providesTags: ["InviteController"],
      }),
      postNotice: build.mutation<PostNoticeApiResponse, PostNoticeApiArg>({
        query: (queryArg) => ({
          url: `/notice`,
          method: "POST",
          body: queryArg.notice,
        }),
        invalidatesTags: ["NoticeController"],
      }),
      getNoticesByPropertyId: build.query<
        GetNoticesByPropertyIdApiResponse,
        GetNoticesByPropertyIdApiArg
      >({
        query: (queryArg) => ({ url: `/notices/${queryArg.propertyId}` }),
        providesTags: ["NoticeController"],
      }),
      getPadelBookingsAvailable: build.query<
        GetPadelBookingsAvailableApiResponse,
        GetPadelBookingsAvailableApiArg
      >({
        query: (queryArg) => ({
          url: `/padel-bookings/available`,
          params: { date: queryArg.date },
        }),
        providesTags: ["PadelBookingController"],
      }),
      postPadelBookings: build.mutation<
        PostPadelBookingsApiResponse,
        PostPadelBookingsApiArg
      >({
        query: (queryArg) => ({
          url: `/padel-bookings`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PadelBookingController"],
      }),
      getPadelBookings: build.query<
        GetPadelBookingsApiResponse,
        GetPadelBookingsApiArg
      >({
        query: (queryArg) => ({
          url: `/padel-bookings`,
          params: { propertyId: queryArg.propertyId },
        }),
        providesTags: ["PadelBookingController"],
      }),
      getPasswordResetIsResetLinkValidByResetId: build.query<
        GetPasswordResetIsResetLinkValidByResetIdApiResponse,
        GetPasswordResetIsResetLinkValidByResetIdApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/is-reset-link-valid/${queryArg.resetId}`,
        }),
        providesTags: ["PasswordResetRequestController"],
      }),
      postPasswordResetRequestByUserEmail: build.mutation<
        PostPasswordResetRequestByUserEmailApiResponse,
        PostPasswordResetRequestByUserEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/request/${queryArg.userEmail}`,
          method: "POST",
        }),
        invalidatesTags: ["PasswordResetRequestController"],
      }),
      postPasswordResetResetPassword: build.mutation<
        PostPasswordResetResetPasswordApiResponse,
        PostPasswordResetResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/password-reset/reset-password`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PasswordResetRequestController"],
      }),
      postPaymentsAdmin: build.mutation<
        PostPaymentsAdminApiResponse,
        PostPaymentsAdminApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/admin`,
          method: "POST",
          body: queryArg.paymentData,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      getPaymentsAdmin: build.query<
        GetPaymentsAdminApiResponse,
        GetPaymentsAdminApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/admin`,
          params: {
            name: queryArg.name,
            email: queryArg.email,
            purpose: queryArg.purpose,
            paymentMethod: queryArg.paymentMethod,
            paymentIntentId: queryArg.paymentIntentId,
            paymentDate: queryArg.paymentDate,
            fromDate: queryArg.fromDate,
            toDate: queryArg.toDate,
            development: queryArg.development,
            phase: queryArg.phase,
            type: queryArg["type"],
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["PaymentController"],
      }),
      postPaymentsIntents: build.mutation<
        PostPaymentsIntentsApiResponse,
        PostPaymentsIntentsApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/intents`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      postPaymentsPaynowStatus: build.mutation<
        PostPaymentsPaynowStatusApiResponse,
        PostPaymentsPaynowStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/paynow/status`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      postPaymentsPaynowCallback: build.mutation<
        PostPaymentsPaynowCallbackApiResponse,
        PostPaymentsPaynowCallbackApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/paynow-callback`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      postPaymentsReconcilePending: build.mutation<
        PostPaymentsReconcilePendingApiResponse,
        PostPaymentsReconcilePendingApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/reconcile-pending`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      getPaymentsUser: build.query<
        GetPaymentsUserApiResponse,
        GetPaymentsUserApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/user`,
          params: { propertyId: queryArg.propertyId },
        }),
        providesTags: ["PaymentController"],
      }),
      postPaymentsByIdRetryTopup: build.mutation<
        PostPaymentsByIdRetryTopupApiResponse,
        PostPaymentsByIdRetryTopupApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.id}/retry-topup`,
          method: "POST",
        }),
        invalidatesTags: ["PaymentController"],
      }),
      putPaymentsByPaymentIntentId: build.mutation<
        PutPaymentsByPaymentIntentIdApiResponse,
        PutPaymentsByPaymentIntentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/payments/${queryArg.paymentIntentId}`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["PaymentController"],
      }),
      getPing: build.query<GetPingApiResponse, GetPingApiArg>({
        query: () => ({ url: `/ping` }),
        providesTags: ["PingController"],
      }),
      getPropertiesOwnerByOwnerId: build.query<
        GetPropertiesOwnerByOwnerIdApiResponse,
        GetPropertiesOwnerByOwnerIdApiArg
      >({
        query: (queryArg) => ({ url: `/properties/owner/${queryArg.ownerId}` }),
        providesTags: ["PropertyController"],
      }),
      getProperties: build.query<GetPropertiesApiResponse, GetPropertiesApiArg>(
        {
          query: () => ({ url: `/properties` }),
          providesTags: ["PropertyController"],
        }
      ),
      getPropertyNameById: build.query<
        GetPropertyNameByIdApiResponse,
        GetPropertyNameByIdApiArg
      >({
        query: (queryArg) => ({ url: `/property/name/${queryArg.id}` }),
        providesTags: ["PropertyController"],
      }),
      getPropertyByPropertyIdInvitesVisits: build.query<
        GetPropertyByPropertyIdInvitesVisitsApiResponse,
        GetPropertyByPropertyIdInvitesVisitsApiArg
      >({
        query: (queryArg) => ({
          url: `/property/${queryArg.propertyId}/invites-visits`,
        }),
        providesTags: ["InviteController"],
      }),
      getPropertyByPropertyIdInvoices: build.query<
        GetPropertyByPropertyIdInvoicesApiResponse,
        GetPropertyByPropertyIdInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/property/${queryArg.propertyId}/invoices`,
        }),
        providesTags: ["PropertyInvoiceController"],
      }),
      getPropertyById: build.query<
        GetPropertyByIdApiResponse,
        GetPropertyByIdApiArg
      >({
        query: (queryArg) => ({ url: `/property/${queryArg.id}` }),
        providesTags: ["PropertyController"],
      }),
      deletePropertyById: build.mutation<
        DeletePropertyByIdApiResponse,
        DeletePropertyByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/property/${queryArg.id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["PropertyController"],
      }),
      postProperty: build.mutation<PostPropertyApiResponse, PostPropertyApiArg>(
        {
          query: (queryArg) => ({
            url: `/property`,
            method: "POST",
            body: queryArg.property,
          }),
          invalidatesTags: ["PropertyController"],
        }
      ),
      patchProperty: build.mutation<
        PatchPropertyApiResponse,
        PatchPropertyApiArg
      >({
        query: (queryArg) => ({
          url: `/property`,
          method: "PATCH",
          body: queryArg.propertyPartial,
        }),
        invalidatesTags: ["PropertyController"],
      }),
      patchPropertyInvoicesById: build.mutation<
        PatchPropertyInvoicesByIdApiResponse,
        PatchPropertyInvoicesByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/property-invoices/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.propertyInvoicePartial,
        }),
        invalidatesTags: ["PropertyInvoiceController"],
      }),
      getPropertyInvoicesById: build.query<
        GetPropertyInvoicesByIdApiResponse,
        GetPropertyInvoicesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/property-invoices/${queryArg.id}` }),
        providesTags: ["PropertyInvoiceController"],
      }),
      postPropertyInvoices: build.mutation<
        PostPropertyInvoicesApiResponse,
        PostPropertyInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/property-invoices`,
          method: "POST",
          body: queryArg.newPropertyInvoice,
        }),
        invalidatesTags: ["PropertyInvoiceController"],
      }),
      getPropertyInvoices: build.query<
        GetPropertyInvoicesApiResponse,
        GetPropertyInvoicesApiArg
      >({
        query: (queryArg) => ({
          url: `/property-invoices`,
          params: {
            invoiceNumber: queryArg.invoiceNumber,
            paid: queryArg.paid,
            development: queryArg.development,
            phase: queryArg.phase,
            type: queryArg["type"],
            dueDate: queryArg.dueDate,
            unitNumber: queryArg.unitNumber,
            limit: queryArg.limit,
            skip: queryArg.skip,
          },
        }),
        providesTags: ["PropertyInvoiceController"],
      }),
      getUserById: build.query<GetUserByIdApiResponse, GetUserByIdApiArg>({
        query: (queryArg) => ({ url: `/user/${queryArg.id}` }),
        providesTags: ["UserController"],
      }),
      postUsersLogin: build.mutation<
        PostUsersLoginApiResponse,
        PostUsersLoginApiArg
      >({
        query: (queryArg) => ({
          url: `/users/login`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsersLogout: build.mutation<
        PostUsersLogoutApiResponse,
        PostUsersLogoutApiArg
      >({
        query: () => ({ url: `/users/logout`, method: "POST" }),
        invalidatesTags: ["UserController"],
      }),
      getUsersMe: build.query<GetUsersMeApiResponse, GetUsersMeApiArg>({
        query: () => ({ url: `/users/me` }),
        providesTags: ["UserController"],
      }),
      postUsersResetPassword: build.mutation<
        PostUsersResetPasswordApiResponse,
        PostUsersResetPasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/users/reset-password`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["UserController"],
      }),
      postUsers: build.mutation<PostUsersApiResponse, PostUsersApiArg>({
        query: (queryArg) => ({
          url: `/users`,
          method: "POST",
          body: queryArg.userWithPassword,
        }),
        invalidatesTags: ["UserController"],
      }),
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: () => ({ url: `/users` }),
        providesTags: ["UserController"],
      }),
      getWhoAmI: build.query<GetWhoAmIApiResponse, GetWhoAmIApiArg>({
        query: () => ({ url: `/whoAmI` }),
        providesTags: ["UserController"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as residentPortalApi };
export type PostAddInviteApiResponse = /** status 200 Invite */ Invite;
export type PostAddInviteApiArg = {
  inviteData: InviteData;
};
export type PatchAdminCannedResponsesByIdApiResponse =
  /** status 200 Updated template */ CannedResponse;
export type PatchAdminCannedResponsesByIdApiArg = {
  id: string;
  cannedResponsePartialExcludingIdCreatedAt: CannedResponsePartialExcludingIdCreatedAt;
};
export type GetAdminCannedResponsesByIdApiResponse =
  /** status 200 Canned response */ CannedResponse;
export type GetAdminCannedResponsesByIdApiArg = {
  id: string;
};
export type DeleteAdminCannedResponsesByIdApiResponse = unknown;
export type DeleteAdminCannedResponsesByIdApiArg = {
  id: string;
};
export type PostAdminCannedResponsesApiResponse =
  /** status 200 Created template */ CannedResponse;
export type PostAdminCannedResponsesApiArg = {
  cannedResponseExcludingIdCreatedAtUpdatedAt: CannedResponseExcludingIdCreatedAtUpdatedAt;
};
export type GetAdminCannedResponsesApiResponse =
  /** status 200 Canned response templates */ CannedResponse[];
export type GetAdminCannedResponsesApiArg = {
  category?: string;
};
export type PatchAdminComplianceCertificatesByIdApiResponse =
  /** status 200 Updated certificate */ ComplianceCertificate;
export type PatchAdminComplianceCertificatesByIdApiArg = {
  id: string;
  complianceCertificatePartialExcludingIdCreatedAt: ComplianceCertificatePartialExcludingIdCreatedAt;
};
export type GetAdminComplianceCertificatesByIdApiResponse =
  /** status 200 Certificate */ ComplianceCertificate;
export type GetAdminComplianceCertificatesByIdApiArg = {
  id: string;
};
export type DeleteAdminComplianceCertificatesByIdApiResponse = unknown;
export type DeleteAdminComplianceCertificatesByIdApiArg = {
  id: string;
};
export type PostAdminComplianceCertificatesApiResponse =
  /** status 200 Created certificate */ ComplianceCertificate;
export type PostAdminComplianceCertificatesApiArg = {
  complianceCertificateExcludingIdCreatedAtUpdatedAtIsExpired: ComplianceCertificateExcludingIdCreatedAtUpdatedAtIsExpired;
};
export type GetAdminComplianceCertificatesApiResponse =
  /** status 200 Compliance certificates */ ComplianceCertificate[];
export type GetAdminComplianceCertificatesApiArg = {
  propertyId?: string;
  certType?: string;
  expiringSoon?: boolean;
};
export type GetAdminInvitesVisitsApiResponse =
  /** status 200 Invites and visits across properties for admin and support users */ {
    id?: string;
    propertyId?: string;
    development?: string;
    phase?: string;
    propertyNumber?: number;
    visitorName?: string;
    visitorWhatsApp?: string;
    visitorEmail?: string;
    visitDateTime?: string;
    startDate?: string;
    endDate?: string;
    isMultiDay?: boolean;
    visitorType?: string;
    purpose?: string;
    invitedByType?: string;
    parentInviteId?: string;
    scanned?: boolean;
    scannedAt?: string;
    scanCount?: number;
    revoked?: boolean;
    createdByUserId?: string;
    accessCode?: string;
    currentStatus?: string;
    lastScannedAt?: string;
    consentConfirmed?: boolean;
    expectedCheckoutAt?: string;
  }[];
export type GetAdminInvitesVisitsApiArg = {
  development?: string;
  phase?: string;
  propertyNumber?: number;
  propertyId?: string;
  visitorType?: string;
  invitedByType?: string;
  revoked?: boolean;
  scanned?: boolean;
  fromDate?: string;
  toDate?: string;
  search?: string;
};
export type PatchAdminKnowledgeArticlesByIdApiResponse =
  /** status 200 Updated knowledge article */ KnowledgeArticle;
export type PatchAdminKnowledgeArticlesByIdApiArg = {
  id: string;
  body: {
    title?: string;
    body?: string;
    category?: string;
    tags?: string[];
    isPublished?: boolean;
  };
};
export type DeleteAdminKnowledgeArticlesByIdApiResponse = unknown;
export type DeleteAdminKnowledgeArticlesByIdApiArg = {
  id: string;
};
export type PostAdminKnowledgeArticlesApiResponse =
  /** status 200 Created knowledge article */ KnowledgeArticle;
export type PostAdminKnowledgeArticlesApiArg = {
  body: {
    title: string;
    body: string;
    category: string;
    tags?: string[];
    sourceTicketId?: string;
    isPublished?: boolean;
  };
};
export type GetAdminKnowledgeArticlesApiResponse =
  /** status 200 All knowledge articles */ KnowledgeArticle[];
export type GetAdminKnowledgeArticlesApiArg = {
  category?: string;
  published?: boolean;
};
export type GetAdminMaintenanceAccountsPayableApiResponse =
  /** status 200 Unpaid vendor invoices grouped by vendor */ object;
export type GetAdminMaintenanceAccountsPayableApiArg = {
  vendorId?: string;
};
export type GetAdminMaintenanceAgingReportApiResponse =
  /** status 200 Active tickets grouped by status with age buckets */ object;
export type GetAdminMaintenanceAgingReportApiArg = {
  propertyId?: string;
};
export type GetAdminMaintenanceAssetCostHistoryByAssetIdApiResponse =
  /** status 200 Lifetime cost history and monthly trend for an asset */ object;
export type GetAdminMaintenanceAssetCostHistoryByAssetIdApiArg = {
  assetId: string;
};
export type PostAdminMaintenanceCostItemsByItemIdApproveApiResponse =
  /** status 200 Approved cost line item */ MaintenanceCostItem;
export type PostAdminMaintenanceCostItemsByItemIdApproveApiArg = {
  itemId: string;
};
export type PatchAdminMaintenanceCostItemsByItemIdApiResponse =
  /** status 200 Updated cost line item */ MaintenanceCostItem;
export type PatchAdminMaintenanceCostItemsByItemIdApiArg = {
  itemId: string;
  body: {
    description?: string;
    amount?: number;
    invoiceUrl?: string;
    invoiceNumber?: string;
    vendorId?: string;
    glCode?: string;
    costCenter?: string;
    expenseType?: "operating" | "capital";
    paymentStatus?: "unpaid" | "paid";
  };
};
export type DeleteAdminMaintenanceCostItemsByItemIdApiResponse = unknown;
export type DeleteAdminMaintenanceCostItemsByItemIdApiArg = {
  itemId: string;
};
export type GetAdminMaintenanceResponseMetricsApiResponse =
  /** status 200 Average intake / dispatch / repair durations, overall and per category */ object;
export type GetAdminMaintenanceResponseMetricsApiArg = {
  propertyId?: string;
  from?: string;
  to?: string;
};
export type PostAdminMaintenanceRunEscalationsApiResponse =
  /** status 200 Escalation summary */ object;
export type PostAdminMaintenanceRunEscalationsApiArg = void;
export type GetAdminMaintenanceAssetsByIdTicketHistoryApiResponse =
  /** status 200 Tickets linked to this asset */ any;
export type GetAdminMaintenanceAssetsByIdTicketHistoryApiArg = {
  id: string;
};
export type PatchAdminMaintenanceAssetsByIdApiResponse =
  /** status 200 Updated asset */ MaintenanceAsset;
export type PatchAdminMaintenanceAssetsByIdApiArg = {
  id: string;
  maintenanceAssetPartialExcludingIdCreatedAt: MaintenanceAssetPartialExcludingIdCreatedAt;
};
export type GetAdminMaintenanceAssetsByIdApiResponse =
  /** status 200 Asset */ MaintenanceAsset;
export type GetAdminMaintenanceAssetsByIdApiArg = {
  id: string;
};
export type DeleteAdminMaintenanceAssetsByIdApiResponse = unknown;
export type DeleteAdminMaintenanceAssetsByIdApiArg = {
  id: string;
};
export type PostAdminMaintenanceAssetsApiResponse =
  /** status 200 Created asset */ MaintenanceAsset;
export type PostAdminMaintenanceAssetsApiArg = {
  maintenanceAssetExcludingIdCreatedAtUpdatedAtTicketCount: MaintenanceAssetExcludingIdCreatedAtUpdatedAtTicketCount;
};
export type GetAdminMaintenanceAssetsApiResponse =
  /** status 200 Array of maintenance assets */ MaintenanceAsset[];
export type GetAdminMaintenanceAssetsApiArg = {
  propertyId?: string;
  category?: string;
};
export type PostAdminMaintenanceTicketsByIdCostItemsApiResponse =
  /** status 200 Created cost line item */ MaintenanceCostItem;
export type PostAdminMaintenanceTicketsByIdCostItemsApiArg = {
  id: string;
  body: {
    description: string;
    amount: number;
    invoiceUrl?: string;
    invoiceNumber?: string;
    vendorId?: string;
    glCode?: string;
    costCenter?: string;
    expenseType?: "operating" | "capital";
    paymentStatus?: "unpaid" | "paid";
  };
};
export type GetAdminMaintenanceTicketsByIdCostItemsApiResponse =
  /** status 200 Cost line items for the ticket */ MaintenanceCostItem[];
export type GetAdminMaintenanceTicketsByIdCostItemsApiArg = {
  id: string;
};
export type PostAdminMaintenanceTicketsByIdMergeApiResponse =
  /** status 200 The surviving (primary) ticket */ MaintenanceTicket;
export type PostAdminMaintenanceTicketsByIdMergeApiArg = {
  id: string;
  body: {
    duplicateTicketIds: string[];
  };
};
export type PostAdminMaintenanceTicketsByIdSplitApiResponse =
  /** status 200 The newly created tickets */ MaintenanceTicket[];
export type PostAdminMaintenanceTicketsByIdSplitApiArg = {
  id: string;
  body: {
    parts: {
      title: string;
      description: string;
      category: string;
      priority?: "low" | "medium" | "high" | "urgent" | "emergency";
    }[];
    closeOriginal?: boolean;
  };
};
export type PatchAdminMaintenanceTicketsByIdApiResponse =
  /** status 200 Updated maintenance ticket */ MaintenanceTicket;
export type PatchAdminMaintenanceTicketsByIdApiArg = {
  id: string;
  body: {
    status?: "open" | "in-progress" | "resolved" | "closed";
    adminNotes?: string;
  };
};
export type GetAdminMaintenanceTicketsApiResponse =
  /** status 200 List of all maintenance tickets */ MaintenanceTicket[];
export type GetAdminMaintenanceTicketsApiArg = {
  status?: string;
  propertyId?: string;
  category?: string;
};
export type PostAdminMigratePropertyOwnersApiResponse =
  /** status 200 Migration Response */ MigrationResponse;
export type PostAdminMigratePropertyOwnersApiArg = void;
export type GetAdminPadelBookingsByIdApiResponse =
  /** status 200 Padel court booking detail */ PadelBooking;
export type GetAdminPadelBookingsByIdApiArg = {
  id: string;
};
export type GetAdminPadelBookingsApiResponse =
  /** status 200 List of all padel court bookings */ PadelBooking[];
export type GetAdminPadelBookingsApiArg = {
  date?: string;
  propertyId?: string;
  status?: string;
};
export type PostAdminPreventiveMaintenanceGenerateDueApiResponse =
  /** status 200 Generated ticket IDs */ {
    generated?: string[];
  };
export type PostAdminPreventiveMaintenanceGenerateDueApiArg = void;
export type PostAdminPreventiveMaintenanceByIdGenerateApiResponse =
  /** status 200 Generated maintenance ticket */ object;
export type PostAdminPreventiveMaintenanceByIdGenerateApiArg = {
  id: string;
};
export type PatchAdminPreventiveMaintenanceByIdApiResponse =
  /** status 200 Updated schedule */ PreventiveMaintenance;
export type PatchAdminPreventiveMaintenanceByIdApiArg = {
  id: string;
  preventiveMaintenancePartialExcludingIdCreatedAt: PreventiveMaintenancePartialExcludingIdCreatedAt;
};
export type GetAdminPreventiveMaintenanceByIdApiResponse =
  /** status 200 Schedule */ PreventiveMaintenance;
export type GetAdminPreventiveMaintenanceByIdApiArg = {
  id: string;
};
export type DeleteAdminPreventiveMaintenanceByIdApiResponse = unknown;
export type DeleteAdminPreventiveMaintenanceByIdApiArg = {
  id: string;
};
export type PostAdminPreventiveMaintenanceApiResponse =
  /** status 200 Created schedule */ PreventiveMaintenance;
export type PostAdminPreventiveMaintenanceApiArg = {
  preventiveMaintenanceExcludingIdCreatedAtUpdatedAtLastGeneratedTicketIdLastCompletedDate: PreventiveMaintenanceExcludingIdCreatedAtUpdatedAtLastGeneratedTicketIdLastCompletedDate;
};
export type GetAdminPreventiveMaintenanceApiResponse =
  /** status 200 Preventive maintenance schedules */ PreventiveMaintenance[];
export type GetAdminPreventiveMaintenanceApiArg = {
  propertyId?: string;
  dueOnly?: boolean;
};
export type PostAdminVendorsByIdRecordJobApiResponse =
  /** status 200 Updated vendor scorecard */ Vendor;
export type PostAdminVendorsByIdRecordJobApiArg = {
  id: string;
  body: {
    cost?: number;
    responseTimeHours?: number;
    qualityRating: number;
  };
};
export type PatchAdminVendorsByIdApiResponse =
  /** status 200 Updated vendor */ Vendor;
export type PatchAdminVendorsByIdApiArg = {
  id: string;
  vendorPartialExcludingIdCreatedAt: VendorPartialExcludingIdCreatedAt;
};
export type GetAdminVendorsByIdApiResponse = /** status 200 Vendor */ Vendor;
export type GetAdminVendorsByIdApiArg = {
  id: string;
};
export type DeleteAdminVendorsByIdApiResponse = unknown;
export type DeleteAdminVendorsByIdApiArg = {
  id: string;
};
export type PostAdminVendorsApiResponse =
  /** status 200 Created vendor */ Vendor;
export type PostAdminVendorsApiArg = {
  vendorExcludingIdCreatedAtUpdatedAt: VendorExcludingIdCreatedAtUpdatedAt;
};
export type GetAdminVendorsApiResponse =
  /** status 200 Array of vendors */ Vendor[];
export type GetAdminVendorsApiArg = {
  category?: string;
  activeOnly?: boolean;
};
export type PostApiCreateSubscriptionIntentApiResponse =
  /** status 200 Stripe Payment Intent for Internet Package (non-subscription) */ {
    clientSecret?: string;
    paymentIntentId?: string;
    provider?: string;
  };
export type PostApiCreateSubscriptionIntentApiArg = {
  body: {
    packageId: string;
    propertyId: string;
  };
};
export type GetFinanceOutstandingLeviesApiResponse =
  /** status 200 Outstanding Levies by development and phase */ {
    totalOutstanding?: number;
    totalByDevelopment?: {
      [key: string]: number;
    };
    totalByDevelopmentAndPhase?: {
      [key: string]: {
        [key: string]: number;
      };
    };
  };
export type GetFinanceOutstandingLeviesApiArg = void;
export type GetFinancePaymentsApiResponse =
  /** status 200 Array of payment instances */ PaymentWithRelations[];
export type GetFinancePaymentsApiArg = {
  name?: string;
  email?: string;
  purpose?: string;
  paymentMethod?: string;
  paymentDate?: string;
  development?: string;
  phase?: string;
  type?: string;
  limit?: number;
  skip?: number;
};
export type GetFinanceRevenuesApiResponse =
  /** status 200 Revenue summary grouped by purpose */ {
    gas?: number;
    water?: number;
    electricity?: number;
    levies?: number;
    internet?: number;
  };
export type GetFinanceRevenuesApiArg = {
  range?: string;
};
export type PostInternetBoosterApiResponse =
  /** status 200 Purchase internet data cap booster (not prorated) */ object;
export type PostInternetBoosterApiArg = {
  body: {
    propertyId: string;
  };
};
export type GetInternetProRataApiResponse =
  /** status 200 Preview current month pro-rata internet charge */ {
    propertyId?: string;
    packageId?: string;
    periodStart?: string;
    periodEnd?: string;
    startDate?: string;
    daysInMonth?: number;
    activeDays?: number;
    monthlyCents?: number;
    proRataCents?: number;
    isProrated?: boolean;
  };
export type GetInternetProRataApiArg = {
  propertyId?: string;
  packageId?: string;
};
export type PostInternetUpgradeApiResponse =
  /** status 200 Upgrade internet package mid-month with prorated price difference */ object;
export type PostInternetUpgradeApiArg = {
  body: {
    propertyId: string;
    newPackageId: string;
    effectiveDate?: string;
  };
};
export type PatchInternetInvoicesByIdApiResponse =
  /** status 200 InternetInvoice PATCH success */ object;
export type PatchInternetInvoicesByIdApiArg = {
  id: string;
  body: object;
};
export type GetInternetInvoicesApiResponse =
  /** status 200 List Internet invoices for a property */ {
    invoice?: object;
    items?: any;
  }[];
export type GetInternetInvoicesApiArg = {
  propertyId?: string;
  status?: string;
};
export type GetInternetPackagesApiResponse =
  /** status 200 Array of internet packages */ InternetPackage[];
export type GetInternetPackagesApiArg = void;
export type GetInternetSubscriptionsActiveApiResponse =
  /** status 200 Active internet subscription for a property */ {
    subscription?: object;
    package?: object;
  };
export type GetInternetSubscriptionsActiveApiArg = {
  propertyId?: string;
};
export type GetInternetUsageByPropertyIdApiResponse =
  /** status 200 Internet usage by property */ InternetUsage;
export type GetInternetUsageByPropertyIdApiArg = {
  propertyId: string;
};
export type PatchInviteMarkAsScannedByIdApiResponse =
  /** status 200 Visitor checked in or checked out */ {
    action?: "check-in" | "check-out";
    scannedAt?: string;
    currentStatus?: string;
    invite?: Invite;
  };
export type PatchInviteMarkAsScannedByIdApiArg = {
  id: string;
  body: {
    photoUrl?: string;
    idScanUrl?: string;
    vehiclePlateNumber?: string;
  };
};
export type PostInviteUploadUrlApiResponse =
  /** status 200 Pre-signed S3 URL to upload a first-visit photo/ID scan for an invite */ {
    uploadUrl?: string;
    fileUrl?: string;
  };
export type PostInviteUploadUrlApiArg = {
  body: {
    filename: string;
    contentType: string;
  };
};
export type PatchInviteByIdResendApiResponse = unknown;
export type PatchInviteByIdResendApiArg = {
  id: string;
};
export type PatchInviteByIdRevokeApiResponse = unknown;
export type PatchInviteByIdRevokeApiArg = {
  id: string;
};
export type GetInviteByIdVisitLogsApiResponse =
  /** status 200 Check-in / check-out history for an invite */ {
    id?: string;
    inviteId?: string;
    action?: string;
    scannedAt?: string;
  }[];
export type GetInviteByIdVisitLogsApiArg = {
  id: string;
};
export type GetInviteByIdApiResponse =
  /** status 200 Invite model instance */ InviteWithRelations;
export type GetInviteByIdApiArg = {
  id: string;
};
export type PostInviteByCodeByCodeSubInviteApiResponse =
  /** status 200 Sub-invite created by BnB guest */ SubInvite;
export type PostInviteByCodeByCodeSubInviteApiArg = {
  code: string;
  subInviteData: SubInviteData;
};
export type GetInviteByCodeByCodeApiResponse =
  /** status 200 Invite fetched by access code */ InviteWithRelations;
export type GetInviteByCodeByCodeApiArg = {
  code: string;
};
export type GetInvitesApiResponse = /** status 200 Invite model instance */ any;
export type GetInvitesApiArg = {
  timeZone?: string;
};
export type PostInvoicePropertyApiResponse =
  /** status 200 Single property levy invoice created */ PropertyInvoiceWithRelations;
export type PostInvoicePropertyApiArg = {
  body: {
    propertyId: string;
    templateInvoiceId: string;
    dueDate?: string;
  };
};
export type PostInvoiceApiResponse = /** status 200 Invoice */ NewInvoice;
export type PostInvoiceApiArg = {
  newInvoice: NewInvoice;
};
export type GetInvoicesApiResponse =
  /** status 200 Array of Invoices */ Invoice[];
export type GetInvoicesApiArg = {
  development?: string;
  type?: string;
  phase?: string;
  fromDate?: string;
  toDate?: string;
  isGeneric?: boolean;
  limit?: number;
  skip?: number;
  order?: string;
};
export type PostItemApiResponse = /** status 200 Item */ Item;
export type PostItemApiArg = {
  item: Item;
};
export type GetItemsApiResponse = /** status 200 Array of items */ Item[];
export type GetItemsApiArg = void;
export type PostKnowledgeArticlesByIdHelpfulApiResponse =
  /** status 200 Updated helpful count */ {
    helpfulCount?: number;
  };
export type PostKnowledgeArticlesByIdHelpfulApiArg = {
  id: string;
};
export type GetKnowledgeArticlesByIdApiResponse =
  /** status 200 A published knowledge article */ KnowledgeArticle;
export type GetKnowledgeArticlesByIdApiArg = {
  id: string;
};
export type GetKnowledgeArticlesApiResponse =
  /** status 200 Published knowledge articles */ KnowledgeArticle[];
export type GetKnowledgeArticlesApiArg = {
  category?: string;
  q?: string;
};
export type PatchMaintenanceMyPreferencesApiResponse =
  /** status 200 Updated resident maintenance preferences */ {
    standingAccessInstructions?: string;
    smsNotificationsEnabled?: boolean;
    phoneNumber?: string;
  };
export type PatchMaintenanceMyPreferencesApiArg = {
  body: {
    standingAccessInstructions?: string;
    smsNotificationsEnabled?: boolean;
    phoneNumber?: string;
  };
};
export type GetMaintenanceMyPreferencesApiResponse =
  /** status 200 Resident maintenance preferences */ {
    standingAccessInstructions?: string;
    smsNotificationsEnabled?: boolean;
    phoneNumber?: string;
  };
export type GetMaintenanceMyPreferencesApiArg = void;
export type GetMaintenanceTransparencyStatsApiResponse =
  /** status 200 Aggregate, redacted maintenance performance stats */ {
    windowDays?: number;
    ticketsResolved?: number;
    ticketsOpened?: number;
    avgResolutionHours?: number;
    satisfactionScore?: number;
    surveyResponses?: number;
    categoryBreakdown?: object;
  };
export type GetMaintenanceTransparencyStatsApiArg = {
  days?: number;
};
export type GetMaintenanceTicketsCommonAreaApiResponse =
  /** status 200 Open common-area tickets for the property */ MaintenanceTicket[];
export type GetMaintenanceTicketsCommonAreaApiArg = {
  propertyId?: string;
};
export type PostMaintenanceTicketsUploadUrlApiResponse =
  /** status 200 Pre-signed upload URL */ {
    uploadUrl?: string;
    fileUrl?: string;
  };
export type PostMaintenanceTicketsUploadUrlApiArg = {
  body: {
    filename: string;
    contentType: string;
  };
};
export type PostMaintenanceTicketsByIdConfirmCompletionApiResponse =
  /** status 200 Updated maintenance ticket */ MaintenanceTicket;
export type PostMaintenanceTicketsByIdConfirmCompletionApiArg = {
  id: string;
  body: {
    confirmed: boolean;
    note?: string;
  };
};
export type PostMaintenanceTicketsByIdDisputeApiResponse =
  /** status 200 Updated maintenance ticket */ MaintenanceTicket;
export type PostMaintenanceTicketsByIdDisputeApiArg = {
  id: string;
  body: {
    reason: string;
  };
};
export type PostMaintenanceTicketsByIdPlusOneApiResponse =
  /** status 200 Updated affected-resident count */ {
    plusOneCount?: number;
    hasPlusOned?: boolean;
  };
export type PostMaintenanceTicketsByIdPlusOneApiArg = {
  id: string;
};
export type PostMaintenanceTicketsByIdQuoteDecisionApiResponse =
  /** status 200 Updated maintenance ticket */ MaintenanceTicket;
export type PostMaintenanceTicketsByIdQuoteDecisionApiArg = {
  id: string;
  body: {
    approved: boolean;
    note?: string;
  };
};
export type PostMaintenanceTicketsByIdSurveyApiResponse =
  /** status 200 Updated maintenance ticket */ MaintenanceTicket;
export type PostMaintenanceTicketsByIdSurveyApiArg = {
  id: string;
  body: {
    communication: number;
    timeliness: number;
    professionalism: number;
    comment?: string;
  };
};
export type PostMaintenanceTicketsByIdWatchApiResponse =
  /** status 200 Updated watcher list */ {
    watchers?: string[];
  };
export type PostMaintenanceTicketsByIdWatchApiArg = {
  id: string;
};
export type DeleteMaintenanceTicketsByIdWatchApiResponse =
  /** status 200 Updated watcher list */ {
    watchers?: string[];
  };
export type DeleteMaintenanceTicketsByIdWatchApiArg = {
  id: string;
};
export type PatchMaintenanceTicketsByIdApiResponse =
  /** status 200 Updated maintenance ticket */ MaintenanceTicket;
export type PatchMaintenanceTicketsByIdApiArg = {
  id: string;
  body: {
    residentNotes?: string;
    attachments?: string[];
    status?: string;
  };
};
export type PostMaintenanceTicketsApiResponse =
  /** status 200 Maintenance ticket created */ MaintenanceTicket;
export type PostMaintenanceTicketsApiArg = {
  body: {
    propertyId: string;
    title: string;
    description: string;
    category:
      | "plumbing"
      | "electrical"
      | "structural"
      | "appliance"
      | "pest-control"
      | "gym-equipment"
      | "pool"
      | "parking"
      | "common-area"
      | "other";
    priority?: "low" | "medium" | "high" | "urgent" | "emergency";
    attachments?: string[];
    locationType?: string;
    amenityLocation?: string;
    preferredEntryWindow?: string;
    petsPresent?: boolean;
    accessInstructions?: string;
  };
};
export type GetMaintenanceTicketsApiResponse =
  /** status 200 Array of maintenance tickets for a property */ MaintenanceTicket[];
export type GetMaintenanceTicketsApiArg = {
  propertyId?: string;
  ticketNumber?: number;
};
export type GetMediaUploadUrlByInviteIdApiResponse =
  /** status 200 Get URL for S3 file upload */ UploadUrl;
export type GetMediaUploadUrlByInviteIdApiArg = {
  inviteId: string;
};
export type GetMeterHistoricByImeiAndStartDateEndDateApiResponse =
  /** status 200 Meter Reading */ MeterResult[];
export type GetMeterHistoricByImeiAndStartDateEndDateApiArg = {
  imei: string;
  startDate: string;
  endDate: string;
};
export type PostMeterOrdersStatusApiResponse =
  /** status 200 List of Order Statuses */ OrderStatus[];
export type PostMeterOrdersStatusApiArg = {
  /** Array of order IDs */
  body: {
    orderIds: string[];
  };
};
export type GetMeterReadByImeiApiResponse =
  /** status 200 Meter Reading */ MeterArchive;
export type GetMeterReadByImeiApiArg = {
  imei: string;
};
export type GetMyPropertyInvitesApiResponse =
  /** status 200 Array of Invites for properties owned by the user */ InviteWithRelations[];
export type GetMyPropertyInvitesApiArg = {
  timeZone?: string;
};
export type PostNoticeApiResponse = /** status 200 Notice */ Notice;
export type PostNoticeApiArg = {
  notice: Notice;
};
export type GetNoticesByPropertyIdApiResponse =
  /** status 200 Array of notices */ NoticeWithRelations[];
export type GetNoticesByPropertyIdApiArg = {
  propertyId: string;
};
export type GetPadelBookingsAvailableApiResponse =
  /** status 200 Available padel court slots for the given date */ {
    date?: string;
    availableSlots?: number[];
    bookedSlots?: number[];
  };
export type GetPadelBookingsAvailableApiArg = {
  date?: string;
};
export type PostPadelBookingsApiResponse =
  /** status 200 Padel court booking created without payment */ {
    bookingId?: string;
    status?: string;
    message?: string;
  };
export type PostPadelBookingsApiArg = {
  body: {
    propertyId: string;
    /** Booking date in YYYY-MM-DD format */
    date: string;
    /** Start hours (24-h) for each slot, e.g. [8,9,10] */
    slots: number[];
  };
};
export type GetPadelBookingsApiResponse =
  /** status 200 Padel court bookings for a property */ PadelBooking[];
export type GetPadelBookingsApiArg = {
  propertyId?: string;
};
export type GetPasswordResetIsResetLinkValidByResetIdApiResponse = unknown;
export type GetPasswordResetIsResetLinkValidByResetIdApiArg = {
  resetId: string;
};
export type PostPasswordResetRequestByUserEmailApiResponse = unknown;
export type PostPasswordResetRequestByUserEmailApiArg = {
  userEmail: string;
};
export type PostPasswordResetResetPasswordApiResponse = unknown;
export type PostPasswordResetResetPasswordApiArg = {
  /** The input for the reset password function */
  body: {
    resetRequestId: string;
    password: string;
  };
};
export type PostPaymentsAdminApiResponse =
  /** status 200 Payment instance */ Payment;
export type PostPaymentsAdminApiArg = {
  paymentData: PaymentData;
};
export type GetPaymentsAdminApiResponse =
  /** status 200 Array of payment instances for admin listing */ PaymentWithRelations[];
export type GetPaymentsAdminApiArg = {
  name?: string;
  email?: string;
  purpose?: string;
  paymentMethod?: string;
  paymentIntentId?: string;
  paymentDate?: string;
  fromDate?: string;
  toDate?: string;
  development?: string;
  phase?: string;
  type?: string;
  limit?: number;
  skip?: number;
};
export type PostPaymentsIntentsApiResponse =
  /** status 200 Payment Intent (Paynow) */ {
    clientSecret?: string;
    provider?: string;
  };
export type PostPaymentsIntentsApiArg = {
  body: {
    amount: number;
    currency: string;
    purpose: string;
    propertyId: string;
    returnUrl?: string;
    provider?: "paynow";
    packageId?: string;
    internetPackageId?: string;
  };
};
export type PostPaymentsPaynowStatusApiResponse =
  /** status 200 Check Paynow payment status */ {
    status?: string;
    paid?: boolean;
    topUpStatus?: string;
    topUpError?: string;
    meterProvider?: string;
    meterId?: string;
    metaInfo?: any;
  };
export type PostPaymentsPaynowStatusApiArg = {
  body: {
    reference: string;
  };
};
export type PostPaymentsPaynowCallbackApiResponse =
  /** status 200 Paynow payment callback */ {
    status?: string;
  };
export type PostPaymentsPaynowCallbackApiArg = {
  body: {
    reference: string;
    paynowreference?: string;
    amount?: string;
    status: string;
    pollurl?: string;
    hash: string;
  };
};
export type PostPaymentsReconcilePendingApiResponse =
  /** status 200 Reconcile today's pending Paynow payments for a property */ {
    propertyId?: string;
    checkedCount?: number;
    updatedCount?: number;
    skippedCount?: number;
    updatedPaymentIds?: string[];
  };
export type PostPaymentsReconcilePendingApiArg = {
  body: {
    propertyId: string;
  };
};
export type GetPaymentsUserApiResponse =
  /** status 200 Array of Payments for a property */ Payment[];
export type GetPaymentsUserApiArg = {
  propertyId?: string;
};
export type PostPaymentsByIdRetryTopupApiResponse =
  /** status 200 Re-run meter top-up on an existing succeeded payment */ {
    paymentId?: string;
    topUpStatus?: string;
    token?: string;
    tokenFirst?: string;
    tokenSecond?: string;
    receiptId?: any;
    remoteSubmitted?: boolean;
    remoteTaskId?: string;
    meterProvider?: string;
    meterId?: string;
    orderId?: string;
    metaInfo?: any;
  };
export type PostPaymentsByIdRetryTopupApiArg = {
  id: string;
};
export type PutPaymentsByPaymentIntentIdApiResponse =
  /** status 200 Payment update success */ {
    success?: boolean;
    updatedPayment?: object;
  };
export type PutPaymentsByPaymentIntentIdApiArg = {
  paymentIntentId: string;
  body: {
    status: string;
  };
};
export type GetPingApiResponse = /** status 200 Ping Response */ PingResponse;
export type GetPingApiArg = void;
export type GetPropertiesOwnerByOwnerIdApiResponse =
  /** status 200 Array of properties */ Property[];
export type GetPropertiesOwnerByOwnerIdApiArg = {
  ownerId: string;
};
export type GetPropertiesApiResponse =
  /** status 200 Array of properties */ Property[];
export type GetPropertiesApiArg = void;
export type GetPropertyNameByIdApiResponse = /** status 200 PropertyName */ {
  propertyName?: string;
};
export type GetPropertyNameByIdApiArg = {
  id: string;
};
export type GetPropertyByPropertyIdInvitesVisitsApiResponse =
  /** status 200 Invites and visits for a specific property */ InviteWithRelations[];
export type GetPropertyByPropertyIdInvitesVisitsApiArg = {
  propertyId: string;
};
export type GetPropertyByPropertyIdInvoicesApiResponse =
  /** status 200 Array of PropertyInvoices by propertyId */ PropertyInvoiceWithRelations[];
export type GetPropertyByPropertyIdInvoicesApiArg = {
  propertyId: string;
};
export type GetPropertyByIdApiResponse = /** status 200 Property */ Property;
export type GetPropertyByIdApiArg = {
  id: string;
};
export type DeletePropertyByIdApiResponse = unknown;
export type DeletePropertyByIdApiArg = {
  id: string;
};
export type PostPropertyApiResponse = /** status 200 Property */ Property;
export type PostPropertyApiArg = {
  property: Property;
};
export type PatchPropertyApiResponse =
  /** status 200 Property PATCH success */ Property;
export type PatchPropertyApiArg = {
  propertyPartial: PropertyPartial;
};
export type PatchPropertyInvoicesByIdApiResponse =
  /** status 200 PropertyInvoice PATCH success */ PropertyInvoiceWithRelations;
export type PatchPropertyInvoicesByIdApiArg = {
  id: string;
  propertyInvoicePartial: PropertyInvoicePartial;
};
export type GetPropertyInvoicesByIdApiResponse =
  /** status 200 PropertyInvoice model instance */ PropertyInvoiceWithRelations;
export type GetPropertyInvoicesByIdApiArg = {
  id: string;
};
export type PostPropertyInvoicesApiResponse =
  /** status 200 PropertyInvoice model instance */ PropertyInvoice;
export type PostPropertyInvoicesApiArg = {
  newPropertyInvoice: NewPropertyInvoice;
};
export type GetPropertyInvoicesApiResponse =
  /** status 200 Array of PropertyInvoice model instances */ PropertyInvoiceWithRelations[];
export type GetPropertyInvoicesApiArg = {
  invoiceNumber?: string;
  paid?: string;
  development?: string;
  phase?: string;
  type?: string;
  dueDate?: string;
  unitNumber?: string;
  limit?: number;
  skip?: number;
};
export type GetUserByIdApiResponse =
  /** status 200 A specified user user */ User;
export type GetUserByIdApiArg = {
  id: string;
};
export type PostUsersLoginApiResponse = /** status 200 Token */ User;
export type PostUsersLoginApiArg = {
  /** The input of login function */
  body: {
    email: string;
    password: string;
  };
};
export type PostUsersLogoutApiResponse = unknown;
export type PostUsersLogoutApiArg = void;
export type GetUsersMeApiResponse = /** status 200 The current user */ User;
export type GetUsersMeApiArg = void;
export type PostUsersResetPasswordApiResponse = /** status 200 User */ User;
export type PostUsersResetPasswordApiArg = {
  /** The input of password reset function */
  body: {
    password: string;
    repeatPassword: string;
  };
};
export type PostUsersApiResponse = /** status 200 User */ User;
export type PostUsersApiArg = {
  userWithPassword: UserWithPassword;
};
export type GetUsersApiResponse = /** status 200 All users */ User[];
export type GetUsersApiArg = void;
export type GetWhoAmIApiResponse = /** status 200 Return current user */ {
  token?: string;
};
export type GetWhoAmIApiArg = void;
export type Invite = {
  id?: string;
  visitorName: string;
  visitorWhatsApp?: string;
  visitorEmail?: string;
  visitDateTime?: string;
  startDate?: string;
  endDate?: string;
  propertyId: string;
  createdByUserId?: string;
  isMultiDay: boolean;
  visitorType?:
    | "bnb"
    | "company"
    | "delivery"
    | "visitor"
    | "guest"
    | "contractor"
    | "service"
    | "meeting"
    | "other";
  purpose?: string;
  invitedByType?: "owner" | "bnb_guest";
  parentInviteId?: string;
  scanned?: boolean;
  revoked?: boolean;
  scanCount?: number;
  scannedAt?: string;
  accessCode?: string;
  currentStatus?: "not_arrived" | "checked_in" | "checked_out";
  lastScannedAt?: string;
  consentConfirmed?: boolean;
  expectedCheckoutAt?: string;
  overstayAlertSentForVisitAt?: string;
  checkInPhotoUrl?: string;
  idScanUrl?: string;
  vehiclePlateNumber?: string;
};
export type InviteData = {
  visitorName: string;
  visitorWhatsApp?: string;
  visitorEmail?: string;
  visitDateTime?: string;
  startDate?: string;
  endDate?: string;
  propertyId: string;
  createdByUserId?: string;
  isMultiDay: boolean;
  visitorType?:
    | "bnb"
    | "company"
    | "delivery"
    | "visitor"
    | "guest"
    | "contractor"
    | "service"
    | "meeting"
    | "other";
  purpose?: string;
  invitedByType?: "owner" | "bnb_guest";
  parentInviteId?: string;
  scanned?: boolean;
  revoked?: boolean;
  scanCount?: number;
  scannedAt?: string;
  accessCode?: string;
  currentStatus?: "not_arrived" | "checked_in" | "checked_out";
  lastScannedAt?: string;
  consentConfirmed?: boolean;
  expectedCheckoutAt?: string;
  overstayAlertSentForVisitAt?: string;
  checkInPhotoUrl?: string;
  idScanUrl?: string;
  vehiclePlateNumber?: string;
};
export type CannedResponse = {
  id?: string;
  title: string;
  message: string;
  category?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
};
export type CannedResponsePartialExcludingIdCreatedAt = {
  title?: string;
  message?: string;
  category?: string;
  isActive?: boolean;
  updatedAt?: string;
};
export type CannedResponseExcludingIdCreatedAtUpdatedAt = {
  title: string;
  message: string;
  category?: string;
  isActive?: boolean;
};
export type ComplianceCertificate = {
  id?: string;
  name: string;
  certType: string;
  certNumber?: string;
  issueDate?: string;
  expiryDate: string;
  reminderDaysBefore?: number;
  documentUrl?: string;
  notes?: string;
  isExpired?: boolean;
  propertyId?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type ComplianceCertificatePartialExcludingIdCreatedAt = {
  name?: string;
  certType?: string;
  certNumber?: string;
  issueDate?: string;
  expiryDate?: string;
  reminderDaysBefore?: number;
  documentUrl?: string;
  notes?: string;
  isExpired?: boolean;
  propertyId?: string;
  updatedAt?: string;
};
export type ComplianceCertificateExcludingIdCreatedAtUpdatedAtIsExpired = {
  name: string;
  certType: string;
  certNumber?: string;
  issueDate?: string;
  expiryDate: string;
  reminderDaysBefore?: number;
  documentUrl?: string;
  notes?: string;
  propertyId?: string;
};
export type KnowledgeArticle = {
  id?: string;
  title: string;
  body: string;
  category: string;
  tags?: string[];
  sourceTicketId?: string;
  isPublished?: boolean;
  helpfulCount?: number;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type MaintenanceCostItem = {
  id?: string;
  description: string;
  amount: number;
  invoiceUrl?: string;
  invoiceNumber?: string;
  glCode?: string;
  costCenter?: string;
  expenseType?: string;
  paymentStatus?: string;
  paidAt?: string;
  paidBy?: string;
  approvalLevelRequired?: string;
  approved?: boolean;
  approvedBy?: string;
  approvedAt?: string;
  createdBy: string;
  createdAt?: string;
  updatedAt?: string;
  ticketId?: string;
  vendorId?: string;
};
export type MaintenanceAsset = {
  id?: string;
  name: string;
  category: string;
  manufacturer?: string;
  model?: string;
  serialNumber?: string;
  installDate?: string;
  lastServiceDate?: string;
  warrantyExpiry?: string;
  ticketCount?: number;
  notes?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  propertyId?: string;
};
export type MaintenanceAssetPartialExcludingIdCreatedAt = {
  name?: string;
  category?: string;
  manufacturer?: string;
  model?: string;
  serialNumber?: string;
  installDate?: string;
  lastServiceDate?: string;
  warrantyExpiry?: string;
  ticketCount?: number;
  notes?: string;
  isActive?: boolean;
  updatedAt?: string;
  propertyId?: string;
};
export type MaintenanceAssetExcludingIdCreatedAtUpdatedAtTicketCount = {
  name: string;
  category: string;
  manufacturer?: string;
  model?: string;
  serialNumber?: string;
  installDate?: string;
  lastServiceDate?: string;
  warrantyExpiry?: string;
  notes?: string;
  isActive?: boolean;
  propertyId?: string;
};
export type MaintenanceTicket = {
  id?: string;
  title: string;
  description: string;
  category: string;
  priority: string;
  status: string;
  userId: string;
  adminNotes?: string;
  residentNotes?: string;
  attachments?: string[];
  assignedTo?: string;
  vendorId?: string;
  estimatedCost?: number;
  actualCost?: number;
  costApproved?: boolean;
  isInsuranceClaim?: boolean;
  claimNumber?: string;
  workStartedAt?: string;
  workCompletedAt?: string;
  createdAt?: string;
  updatedAt?: string;
  propertyId?: string;
  ticketNumber?: number;
  statusChangedAt?: string;
  closeReason?: string;
  closedAt?: string;
  mergedIntoTicketId?: string;
  mergedTicketIds?: string[];
  additionalReporterIds?: string[];
  watchers?: string[];
  plusOneUserIds?: string[];
  locationType?: string;
  amenityLocation?: string;
  preferredEntryWindow?: string;
  petsPresent?: boolean;
  accessInstructions?: string;
  glCode?: string;
  costCenter?: string;
  expenseType?: string;
  assetId?: string;
  parentTicketId?: string;
  splitTicketIds?: string[];
  acknowledgedAt?: string;
  assignedAt?: string;
  escalated?: boolean;
  escalatedAt?: string;
  quoteStatus?: string;
  quoteAmount?: number;
  quoteRespondedAt?: string;
  quoteResponseNote?: string;
  billToResident?: boolean;
  disputeStatus?: string;
  disputeReason?: string;
  disputeRaisedAt?: string;
  disputeResolutionNote?: string;
  disputeResolvedAt?: string;
  residentConfirmationNote?: string;
  residentConfirmedAt?: string;
  residentConfirmationRequestedAt?: string;
  surveyCommunication?: number;
  surveyTimeliness?: number;
  surveyProfessionalism?: number;
  surveyComment?: string;
  surveySubmittedAt?: string;
  knowledgeArticleId?: string;
  autoPriorityApplied?: boolean;
  autoPriorityKeyword?: string;
  splitFromTicketId?: string;
  beforePhotos?: string[];
  afterPhotos?: string[];
};
export type MigrationResponse = {
  processed?: number;
  updated?: number;
  errors?: number;
};
export type PadelBooking = {
  id?: string;
  date: string;
  slots: number[];
  totalAmount: number;
  currency: string;
  paymentReference: string;
  status: string;
  userId: string;
  createdAt?: string;
  propertyId?: string;
};
export type PreventiveMaintenance = {
  id?: string;
  title: string;
  description?: string;
  category: string;
  frequency: string;
  nextDueDate: string;
  lastCompletedDate?: string;
  assignedTo?: string;
  lastGeneratedTicketId?: string;
  isActive?: boolean;
  propertyId?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type PreventiveMaintenancePartialExcludingIdCreatedAt = {
  title?: string;
  description?: string;
  category?: string;
  frequency?: string;
  nextDueDate?: string;
  lastCompletedDate?: string;
  assignedTo?: string;
  lastGeneratedTicketId?: string;
  isActive?: boolean;
  propertyId?: string;
  updatedAt?: string;
};
export type PreventiveMaintenanceExcludingIdCreatedAtUpdatedAtLastGeneratedTicketIdLastCompletedDate =
  {
    title: string;
    description?: string;
    category: string;
    frequency: string;
    nextDueDate: string;
    assignedTo?: string;
    isActive?: boolean;
    propertyId?: string;
  };
export type Vendor = {
  id?: string;
  name: string;
  contactName?: string;
  phone?: string;
  email?: string;
  categories?: string[];
  averageCost?: number;
  averageResponseTimeHours?: number;
  averageQualityRating?: number;
  totalJobsCompleted?: number;
  notes?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
};
export type VendorPartialExcludingIdCreatedAt = {
  name?: string;
  contactName?: string;
  phone?: string;
  email?: string;
  categories?: string[];
  averageCost?: number;
  averageResponseTimeHours?: number;
  averageQualityRating?: number;
  totalJobsCompleted?: number;
  notes?: string;
  isActive?: boolean;
  updatedAt?: string;
};
export type VendorExcludingIdCreatedAtUpdatedAt = {
  name: string;
  contactName?: string;
  phone?: string;
  email?: string;
  categories?: string[];
  averageCost?: number;
  averageResponseTimeHours?: number;
  averageQualityRating?: number;
  totalJobsCompleted?: number;
  notes?: string;
  isActive?: boolean;
};
export type Item = {
  id?: string;
  description?: string;
  development?: string;
  phase?: string;
  type?: string;
  unitPrice: number;
  [key: string]: any;
};
export type InvoiceWithRelations = {
  id?: string;
  development: string;
  type: string;
  phase: string;
  dueDate?: string;
  recurringPeriod?: number;
  recurring?: boolean;
  totalCost: number;
  items?: Item[];
  /** When true, this is a once-off generic invoice not tied to a specific invoice type such as levies. */
  isGeneric?: boolean;
  /** Name of the dynamic balance field on Property this generic invoice applies to, e.g. pedalCourtInvoiceBalance. Required when isGeneric is true. */
  invoiceDescription?: string;
};
export type Meter = {
  /** Existing smart-meter identifier. For token meters this can still hold the vendor meter id. */
  imei: string;
  service: string;
  /** Explicit token meter id when different from the imei field. */
  meterId?: string;
  /** Meter implementation/provider, e.g. zl or token. */
  provider?: string;
  /** Meter category, e.g. smart or token. */
  meterType?: string;
  /** Vendor company code for token meters. */
  company?: string;
  /** Optional vendor-side customer identifier for token meter task operations. */
  customerId?: string;
  /** Optional concentrator id used by the token-meter vendor for remote task dispatch. */
  concentratorId?: string;
  /** When true, the backend will attempt a remote token push after generation. */
  remoteTopUpSupported?: boolean;
  /** Optional remote task flag required by the token-meter vendor. */
  flag?: string;
  /** Optional token-meter vendor protocol id used for automatic task submission. */
  protocolId?: number;
  /** Optional authorization password used by the token-meter vending API. */
  authorizationPassword?: string;
  /** Optional vendor task flag used to read total kWh from token meters. */
  totalReadingFlag?: string;
  /** Optional vendor protocol id used with totalReadingFlag. */
  totalReadingProtocolId?: number;
  /** Optional vendor task flag used to read remaining balance from token meters. */
  balanceReadingFlag?: string;
  /** Optional vendor protocol id used with balanceReadingFlag. */
  balanceReadingProtocolId?: number;
};
export type UserCredentialsWithRelations = {
  id?: string;
  password: string;
  userId: string;
};
export type UserRefreshTokenWithRelations = {
  id?: string;
  ttl: number;
  creation?: string;
  userId: string;
};
export type UserWithRelations = {
  id?: string;
  email: string;
  name?: string;
  roles?: string[];
  phoneNumber?: string;
  smsNotificationsEnabled?: boolean;
  standingAccessInstructions?: string;
  photoUrl?: string;
  previousToken?: string;
  userCredentials?: UserCredentialsWithRelations;
  userRefreshTokens?: UserRefreshTokenWithRelations[];
};
export type InternetPackageWithRelations = {
  id?: string;
  name: string;
  description: string;
  price: number;
  isActive?: boolean;
  dataCap: number;
};
export type PropertyWithRelations = {
  id?: string;
  development: string;
  meters?: Meter[];
  type: string;
  unitArea?: number;
  unitNumber: string;
  phase: string;
  walletBalance?: number;
  /** Internet wallet balance in cents (can be positive or negative) */
  internetWalletBalance?: number;
  ownerEmails?: string[];
  utilityPurchaseSuspended?: boolean;
  internetCapable?: boolean;
  /** ISO date string representing the date from which levies should be generated for this property */
  levyEffectiveDate?: string;
  ownerIds?: string[];
  internetPackageId?: string;
  owners?: UserWithRelations[];
  internetPackage?: InternetPackageWithRelations;
  [key: string]: any;
};
export type PaymentWithRelations = {
  id?: string;
  amount: number;
  currency: string;
  status: string;
  purpose: string;
  paymentIntentId?: string;
  orderId?: string;
  paymentDate?: string;
  paymentMethod: string;
  provider?: string;
  metadata?: object;
  invoiceId?: string;
  propertyId?: string;
  userId?: string;
  invoice?: InvoiceWithRelations;
  property?: PropertyWithRelations;
  user?: UserWithRelations;
};
export type InternetPackage = {
  id?: string;
  name: string;
  description: string;
  price: number;
  isActive?: boolean;
  dataCap: number;
};
export type InternetUsage = {
  username: string;
  totalDownloadGb: number;
  totalUploadGb: number;
  totalDataUsedGb: number;
  month: string;
  year: string;
};
export type InviteWithRelations = {
  id?: string;
  visitorName: string;
  visitorWhatsApp?: string;
  visitorEmail?: string;
  visitDateTime?: string;
  startDate?: string;
  endDate?: string;
  propertyId: string;
  createdByUserId?: string;
  isMultiDay: boolean;
  visitorType?:
    | "bnb"
    | "company"
    | "delivery"
    | "visitor"
    | "guest"
    | "contractor"
    | "service"
    | "meeting"
    | "other";
  purpose?: string;
  invitedByType?: "owner" | "bnb_guest";
  parentInviteId?: string;
  scanned?: boolean;
  revoked?: boolean;
  scanCount?: number;
  scannedAt?: string;
  accessCode?: string;
  currentStatus?: "not_arrived" | "checked_in" | "checked_out";
  lastScannedAt?: string;
  consentConfirmed?: boolean;
  expectedCheckoutAt?: string;
  overstayAlertSentForVisitAt?: string;
  checkInPhotoUrl?: string;
  idScanUrl?: string;
  vehiclePlateNumber?: string;
};
export type SubInvite = {
  id?: string;
  visitorName: string;
  visitorWhatsApp?: string;
  visitorEmail?: string;
  visitDateTime?: string;
  startDate?: string;
  endDate?: string;
  propertyId: string;
  createdByUserId?: string;
  isMultiDay: boolean;
  visitorType?:
    | "bnb"
    | "company"
    | "delivery"
    | "visitor"
    | "guest"
    | "contractor"
    | "service"
    | "meeting"
    | "other";
  purpose?: string;
  invitedByType?: "owner" | "bnb_guest";
  parentInviteId?: string;
  scanned?: boolean;
  revoked?: boolean;
  scanCount?: number;
  scannedAt?: string;
  accessCode?: string;
  currentStatus?: "not_arrived" | "checked_in" | "checked_out";
  lastScannedAt?: string;
  consentConfirmed?: boolean;
  expectedCheckoutAt?: string;
  overstayAlertSentForVisitAt?: string;
  checkInPhotoUrl?: string;
  idScanUrl?: string;
  vehiclePlateNumber?: string;
};
export type SubInviteData = {
  visitorName: string;
  visitorWhatsApp?: string;
  visitorEmail?: string;
  visitDateTime?: string;
  startDate?: string;
  endDate?: string;
  isMultiDay: boolean;
  visitorType?:
    | "bnb"
    | "company"
    | "delivery"
    | "visitor"
    | "guest"
    | "contractor"
    | "service"
    | "meeting"
    | "other";
  purpose?: string;
  currentStatus?: "not_arrived" | "checked_in" | "checked_out";
  lastScannedAt?: string;
  consentConfirmed?: boolean;
  expectedCheckoutAt?: string;
  overstayAlertSentForVisitAt?: string;
  checkInPhotoUrl?: string;
  idScanUrl?: string;
  vehiclePlateNumber?: string;
};
export type PropertyInvoiceWithRelations = {
  id?: string;
  invoiceNumber: string;
  propertyInvoiceBalance?: number;
  invoiceId?: string;
  propertyId?: string;
  status?: string;
  refDate?: string;
  dueDate?: string;
  invoice?: InvoiceWithRelations;
  property?: PropertyWithRelations;
};
export type NewInvoice = {
  development: string;
  type: string;
  phase: string;
  dueDate?: string;
  recurringPeriod?: number;
  recurring?: boolean;
  totalCost: number;
  items?: Item[];
  /** When true, this is a once-off generic invoice not tied to a specific invoice type such as levies. */
  isGeneric?: boolean;
  /** Name of the dynamic balance field on Property this generic invoice applies to, e.g. pedalCourtInvoiceBalance. Required when isGeneric is true. */
  invoiceDescription?: string;
};
export type Invoice = {
  id?: string;
  development: string;
  type: string;
  phase: string;
  dueDate?: string;
  recurringPeriod?: number;
  recurring?: boolean;
  totalCost: number;
  items?: Item[];
  /** When true, this is a once-off generic invoice not tied to a specific invoice type such as levies. */
  isGeneric?: boolean;
  /** Name of the dynamic balance field on Property this generic invoice applies to, e.g. pedalCourtInvoiceBalance. Required when isGeneric is true. */
  invoiceDescription?: string;
};
export type UploadUrl = {
  uploadUrl?: string;
};
export type MeterResult = {
  energyType: string;
  nbonetNetImei: string;
  meterAddress: string;
  readTime: string;
  consumption: number;
  reading: number;
};
export type OrderStatus = {
  id: number;
  archivesId: number;
  dateTime: string;
  sn: string;
  state: number;
  fee: number;
  paymentAmount: number;
};
export type MeterArchive = {
  balance: number;
  remainingAmount?: number;
  battery: number;
  gps: string;
  energyType: string;
  nbonetNetImei: string;
  readTime: string;
  cumulantFlow: number;
  positiveCumulantFlow: number;
  inverseCumulantFlow: number;
  instantFlow: number;
  customerName: string;
  customerAddress: string;
  valveState: boolean;
  reading: number;
  vendorDebug?: object;
};
export type Notice = {
  title: string;
  developments: string[];
  description: string;
  createdByUserId?: string;
};
export type NoticeWithRelations = {
  id?: string;
  title: string;
  developments: string[];
  description: string;
  createdByUserId?: string;
  createdByUser?: UserWithRelations;
};
export type Payment = {
  id?: string;
  amount: number;
  currency: string;
  status: string;
  purpose: string;
  paymentIntentId?: string;
  orderId?: string;
  paymentDate?: string;
  paymentMethod: string;
  provider?: string;
  metadata?: object;
  invoiceId?: string;
  propertyId?: string;
  userId?: string;
};
export type PaymentData = {
  amount: number;
  currency: string;
  status: string;
  purpose: string;
  paymentIntentId?: string;
  orderId?: string;
  paymentDate?: string;
  paymentMethod: string;
  provider?: string;
  metadata?: object;
  invoiceId?: string;
  propertyId?: string;
  userId?: string;
};
export type PingResponse = {
  greeting?: string;
  date?: string;
  url?: string;
  headers?: {
    "Content-Type"?: string;
    [key: string]: any;
  };
};
export type Property = {
  id?: string;
  development: string;
  meters?: Meter[];
  type: string;
  unitArea?: number;
  unitNumber: string;
  phase: string;
  walletBalance?: number;
  /** Internet wallet balance in cents (can be positive or negative) */
  internetWalletBalance?: number;
  ownerEmails?: string[];
  utilityPurchaseSuspended?: boolean;
  internetCapable?: boolean;
  /** ISO date string representing the date from which levies should be generated for this property */
  levyEffectiveDate?: string;
  ownerIds?: string[];
  internetPackageId?: string;
  [key: string]: any;
};
export type PropertyPartial = {
  id?: string;
  development?: string;
  meters?: Meter[];
  type?: string;
  unitArea?: number;
  unitNumber?: string;
  phase?: string;
  walletBalance?: number;
  /** Internet wallet balance in cents (can be positive or negative) */
  internetWalletBalance?: number;
  ownerEmails?: string[];
  utilityPurchaseSuspended?: boolean;
  internetCapable?: boolean;
  /** ISO date string representing the date from which levies should be generated for this property */
  levyEffectiveDate?: string;
  ownerIds?: string[];
  internetPackageId?: string;
  [key: string]: any;
};
export type PropertyInvoicePartial = {
  id?: string;
  invoiceNumber?: string;
  propertyInvoiceBalance?: number;
  invoiceId?: string;
  propertyId?: string;
  status?: string;
  refDate?: string;
  dueDate?: string;
};
export type PropertyInvoice = {
  id?: string;
  invoiceNumber: string;
  propertyInvoiceBalance?: number;
  invoiceId?: string;
  propertyId?: string;
  status?: string;
  refDate?: string;
  dueDate?: string;
};
export type NewPropertyInvoice = {
  invoiceNumber: string;
  propertyInvoiceBalance?: number;
  invoiceId?: string;
  propertyId?: string;
  status?: string;
  refDate?: string;
  dueDate?: string;
};
export type User = {
  id?: string;
  email: string;
  name?: string;
  roles?: string[];
  phoneNumber?: string;
  smsNotificationsEnabled?: boolean;
  standingAccessInstructions?: string;
  photoUrl?: string;
  previousToken?: string;
};
export type UserWithPassword = {
  email: string;
  name?: string;
  phoneNumber?: string;
  smsNotificationsEnabled?: boolean;
  standingAccessInstructions?: string;
  photoUrl?: string;
  password: string;
};
export const {
  usePostAddInviteMutation,
  usePatchAdminCannedResponsesByIdMutation,
  useGetAdminCannedResponsesByIdQuery,
  useDeleteAdminCannedResponsesByIdMutation,
  usePostAdminCannedResponsesMutation,
  useGetAdminCannedResponsesQuery,
  usePatchAdminComplianceCertificatesByIdMutation,
  useGetAdminComplianceCertificatesByIdQuery,
  useDeleteAdminComplianceCertificatesByIdMutation,
  usePostAdminComplianceCertificatesMutation,
  useGetAdminComplianceCertificatesQuery,
  useGetAdminInvitesVisitsQuery,
  usePatchAdminKnowledgeArticlesByIdMutation,
  useDeleteAdminKnowledgeArticlesByIdMutation,
  usePostAdminKnowledgeArticlesMutation,
  useGetAdminKnowledgeArticlesQuery,
  useGetAdminMaintenanceAccountsPayableQuery,
  useGetAdminMaintenanceAgingReportQuery,
  useGetAdminMaintenanceAssetCostHistoryByAssetIdQuery,
  usePostAdminMaintenanceCostItemsByItemIdApproveMutation,
  usePatchAdminMaintenanceCostItemsByItemIdMutation,
  useDeleteAdminMaintenanceCostItemsByItemIdMutation,
  useGetAdminMaintenanceResponseMetricsQuery,
  usePostAdminMaintenanceRunEscalationsMutation,
  useGetAdminMaintenanceAssetsByIdTicketHistoryQuery,
  usePatchAdminMaintenanceAssetsByIdMutation,
  useGetAdminMaintenanceAssetsByIdQuery,
  useDeleteAdminMaintenanceAssetsByIdMutation,
  usePostAdminMaintenanceAssetsMutation,
  useGetAdminMaintenanceAssetsQuery,
  usePostAdminMaintenanceTicketsByIdCostItemsMutation,
  useGetAdminMaintenanceTicketsByIdCostItemsQuery,
  usePostAdminMaintenanceTicketsByIdMergeMutation,
  usePostAdminMaintenanceTicketsByIdSplitMutation,
  usePatchAdminMaintenanceTicketsByIdMutation,
  useGetAdminMaintenanceTicketsQuery,
  usePostAdminMigratePropertyOwnersMutation,
  useGetAdminPadelBookingsByIdQuery,
  useGetAdminPadelBookingsQuery,
  usePostAdminPreventiveMaintenanceGenerateDueMutation,
  usePostAdminPreventiveMaintenanceByIdGenerateMutation,
  usePatchAdminPreventiveMaintenanceByIdMutation,
  useGetAdminPreventiveMaintenanceByIdQuery,
  useDeleteAdminPreventiveMaintenanceByIdMutation,
  usePostAdminPreventiveMaintenanceMutation,
  useGetAdminPreventiveMaintenanceQuery,
  usePostAdminVendorsByIdRecordJobMutation,
  usePatchAdminVendorsByIdMutation,
  useGetAdminVendorsByIdQuery,
  useDeleteAdminVendorsByIdMutation,
  usePostAdminVendorsMutation,
  useGetAdminVendorsQuery,
  usePostApiCreateSubscriptionIntentMutation,
  useGetFinanceOutstandingLeviesQuery,
  useGetFinancePaymentsQuery,
  useGetFinanceRevenuesQuery,
  usePostInternetBoosterMutation,
  useGetInternetProRataQuery,
  usePostInternetUpgradeMutation,
  usePatchInternetInvoicesByIdMutation,
  useGetInternetInvoicesQuery,
  useGetInternetPackagesQuery,
  useGetInternetSubscriptionsActiveQuery,
  useGetInternetUsageByPropertyIdQuery,
  usePatchInviteMarkAsScannedByIdMutation,
  usePostInviteUploadUrlMutation,
  usePatchInviteByIdResendMutation,
  usePatchInviteByIdRevokeMutation,
  useGetInviteByIdVisitLogsQuery,
  useGetInviteByIdQuery,
  usePostInviteByCodeByCodeSubInviteMutation,
  useGetInviteByCodeByCodeQuery,
  useGetInvitesQuery,
  usePostInvoicePropertyMutation,
  usePostInvoiceMutation,
  useGetInvoicesQuery,
  usePostItemMutation,
  useGetItemsQuery,
  usePostKnowledgeArticlesByIdHelpfulMutation,
  useGetKnowledgeArticlesByIdQuery,
  useGetKnowledgeArticlesQuery,
  usePatchMaintenanceMyPreferencesMutation,
  useGetMaintenanceMyPreferencesQuery,
  useGetMaintenanceTransparencyStatsQuery,
  useGetMaintenanceTicketsCommonAreaQuery,
  usePostMaintenanceTicketsUploadUrlMutation,
  usePostMaintenanceTicketsByIdConfirmCompletionMutation,
  usePostMaintenanceTicketsByIdDisputeMutation,
  usePostMaintenanceTicketsByIdPlusOneMutation,
  usePostMaintenanceTicketsByIdQuoteDecisionMutation,
  usePostMaintenanceTicketsByIdSurveyMutation,
  usePostMaintenanceTicketsByIdWatchMutation,
  useDeleteMaintenanceTicketsByIdWatchMutation,
  usePatchMaintenanceTicketsByIdMutation,
  usePostMaintenanceTicketsMutation,
  useGetMaintenanceTicketsQuery,
  useGetMediaUploadUrlByInviteIdQuery,
  useGetMeterHistoricByImeiAndStartDateEndDateQuery,
  usePostMeterOrdersStatusMutation,
  useGetMeterReadByImeiQuery,
  useGetMyPropertyInvitesQuery,
  usePostNoticeMutation,
  useGetNoticesByPropertyIdQuery,
  useGetPadelBookingsAvailableQuery,
  usePostPadelBookingsMutation,
  useGetPadelBookingsQuery,
  useGetPasswordResetIsResetLinkValidByResetIdQuery,
  usePostPasswordResetRequestByUserEmailMutation,
  usePostPasswordResetResetPasswordMutation,
  usePostPaymentsAdminMutation,
  useGetPaymentsAdminQuery,
  usePostPaymentsIntentsMutation,
  usePostPaymentsPaynowStatusMutation,
  usePostPaymentsPaynowCallbackMutation,
  usePostPaymentsReconcilePendingMutation,
  useGetPaymentsUserQuery,
  usePostPaymentsByIdRetryTopupMutation,
  usePutPaymentsByPaymentIntentIdMutation,
  useGetPingQuery,
  useGetPropertiesOwnerByOwnerIdQuery,
  useGetPropertiesQuery,
  useGetPropertyNameByIdQuery,
  useGetPropertyByPropertyIdInvitesVisitsQuery,
  useGetPropertyByPropertyIdInvoicesQuery,
  useGetPropertyByIdQuery,
  useDeletePropertyByIdMutation,
  usePostPropertyMutation,
  usePatchPropertyMutation,
  usePatchPropertyInvoicesByIdMutation,
  useGetPropertyInvoicesByIdQuery,
  usePostPropertyInvoicesMutation,
  useGetPropertyInvoicesQuery,
  useGetUserByIdQuery,
  usePostUsersLoginMutation,
  usePostUsersLogoutMutation,
  useGetUsersMeQuery,
  usePostUsersResetPasswordMutation,
  usePostUsersMutation,
  useGetUsersQuery,
  useGetWhoAmIQuery,
} = injectedRtkApi;
